import { useEffect, useRef, useState } from 'react';
import ReactQuill from 'react-quill';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { useLocation, useNavigate, useSearchParams } from 'react-router-dom';
import DesignServicesIcon from '@mui/icons-material/DesignServices';
import VisibilityIcon from '@mui/icons-material/Visibility';
import { Divider } from '@mui/material';
import { FormControlLabel, FormHelperText, Switch } from '@mui/material';
import { Typography } from '@mui/material';
import Autocomplete from '@mui/material/Autocomplete';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import MenuItem from '@mui/material/MenuItem';
import Step from '@mui/material/Step';
import StepLabel from '@mui/material/StepLabel';
import Stepper from '@mui/material/Stepper';
import TextField from '@mui/material/TextField';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { esES } from '@mui/x-date-pickers/locales';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import dayjs from 'dayjs';
import { useSnackbar } from 'notistack';
import { func } from 'prop-types';
import * as uuid from 'uuid';

import DemographicDataForm from '../../../components/DemographicDataForm/DemographicDataForm';
import EditForm from '../../../components/EditForm/EditForm';
import Form from '../../../components/Form/Form';
import { IsRequiredQuestion } from '../../../components/Form/IsRequiredQuestion.jsx';
import MyPageHeader from '../../../components/MyPageHeader/MyPageHeader';
import { fetchSurveyByIdAndCompanyId } from '../../../features/surveys/surveysSlice';
import IconSidebar from '../../../Layout/IconSidebar/IconSidebar';
import Navbar from '../../../Layout/Navbar/Navbar';
import {
  fetchCategoriesAPI,
  fetchCategoriesByCompanyAPI,
} from '../../../services/getCategories.service';
import { fetchQuestionTypesAPI } from '../../../services/questionTypes.service';
import {
  deleteTemplateQuestionAPI,
  showTemplateAPI,
  updateTemplateAPI,
  updateTemplateOptionAPI,
  updateTemplateQuestionAPI,
} from '../../../services/templates.service';
import client from '../../../utils/axiosInstance';
import { finAntesDeInicio } from '../../../utils/fechaCierre';
import FontSelector from '../../AnswerSurvey/components/FontSelector/FontSelector.jsx';
import PrivacyPolicySection from '../../AnswerSurvey/components/PrivacyPolicySection/PrivacyPolicySection.jsx';
import { MessagesOpenMailBoxSurvey } from '../MessagesOpenMailBoxSurvey/MessagesOpenMailBoxSurvey.jsx';

import { View360 } from './360Vista/View360.jsx';
import { BackgroundBannerImage } from './BackgroundBannerImage/BackgroundBannerImage.jsx';
import { ColorSurvey } from './ColorSurvey/ColorSurvey.jsx';
import Cuestionario from './Cuestionario/Cuestionario';
import { EvaAgentsConfig } from './EvaAgentsConfig/EvaAgentsConfig.jsx';
import { Exclusiveness } from './Exclusividad/Exclusiveness.jsx';
import { WhatsAppForSurvey } from './HasWhatsApp/WhatsAppForSurvey.jsx';
import { HaveReportPDF } from './HaveReportPDF/HaveReportPDF.jsx';
import Intimidad from './Intimidad/Intimidad.jsx';
import Introduction from './Introduction/Introduction';
import IntroductionSurvey from './IntroductionSurvey/IntroductionSurvey.jsx';
import { MessagesSurvey } from './MessagesSurvey/MessagesSurvey.jsx';
import { MultiAnswerSurvey } from './MultiAnswerSurvey/MultiAnswerSurvey.jsx';
import { NeedSentimentalAnalisys } from './NeedSentimentalAnalisys/NeedSentimentalAnalisys.jsx';
import { OpenMailBox } from './OpenMailbox/OpenMailBox.jsx';
import { PaginationSurvey } from './PaginationSurvey/PaginationSurvey.jsx';
import ResponseLimitSection from './ResponseLimitSection/ResponseLimitSection.jsx';
import { SaveOption } from './SaveOption/SaveOption.jsx';
import { NumerationSurvey } from './NumerationSurvey.jsx';

import 'react-quill/dist/quill.snow.css';
import styles from './CreateSurvey.module.css';

const SAVE_OPTION_QUESTION_TYPE_IDS = [1, 2, 8, 16, 21, 22, 28];
const WHATSAPP_QUESTION_TYPE_IDS = [1, 2, 8, 16, 21];

export default function CreateSurvey() {
  const quillModules = {
    toolbar: [
      ['bold', 'italic', 'underline', 'strike'],
      [{ list: 'ordered' }, { list: 'bullet' }],
      [{ header: [1, 2, 3, false] }],
      [{ color: [] }, { background: [] }],
      [{ align: [] }],
      ['link'],
      ['clean'],
    ],
  };
  const userInfo = JSON.parse(localStorage.getItem('userInfo'));

  const [isPreviewQuestion, setIsPreviewQuestion] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const [searchParams] = useSearchParams();
  const [activeStep, setActiveStep] = useState(0);
  const [questionTypes, setQuestionTypes] = useState([]);
  const [questions, setQuestions] = useState([]);
  const [target, setTarget] = useState('');
  const [open, setOpen] = useState(false);
  const [edit, setEdit] = useState(false);
  const [data, setData] = useState(null);
  const [helperText, setHelperText] = useState({});
  const [errorMessage, setErrorMessage] = useState({});
  const [type, setType] = useState(null);
  const [starmsg, setStarmsg] = useState('');
  const [information, setInformation] = useState({
    name: '',
    description: '',
    options: [],
    customOptions: Array(2).fill(''),
    opcionesInputs: Array(2).fill(''),
    stars: Array(3).fill(''),
    rangeOptions: ['Rango 0-6', 'Rango 7-8', 'Rango 9-10'],
    barBipolarValue: 0,
    textsBipolarBar: {
      leftText: '',
      rightText: '',
      valueRight: '2',
      valueLeft: '0',
    },
    isRequired: true,
    needSentimentalAnalisys: false,
    maximunValueOptions: null,
    secondSelectOptions: Array.from({ length: 9 }, (_, i) =>
      (2 + i).toString(),
    ),
    autoValidate: false,
    matrixOption: {
      matrixType: '',
      options: [''],
      values: [''],
      inputType: '',
    },
    tableSetting: {
      options: [
        {
          required: false,
          type: 'text',
          value: '',
        },
      ],
    },
    multimedia: {
      type: '',
      urlMedia: '',
    },
    voiceEnabled: false,
    voiceDuration: 60,
    validationType: 'text',
    wordSizeLimit: 500,
    haveLimit: true,
    limitOptions: 1,
  });
  const [firstSelect, setFirstSelect] = useState(0);
  const [secondSelect, setSecondSelect] = useState(2);
  const [limitType, setLimitType] = useState('ilimitado');

  const [selections, setSelections] = useState({});
  const dispatch = useDispatch();
  const [privacyPolicyEnabled, setPrivacyPolicyEnabled] = useState(false);
  const [dataPrivacyPolicyUrl, setDataPrivacyPolicyUrl] = useState(null);
  const [dataPrivacyPolicyText, setDataPrivacyPolicyText] = useState(
    'Al participar en esta encuesta, usted acepta que sus respuestas serán recopiladas y procesadas de forma confidencial. La información proporcionada será utilizada exclusivamente con fines de análisis y mejora organizacional. Sus datos personales serán tratados de acuerdo con las leyes vigentes de protección de datos. No se compartirá información individual con terceros sin su consentimiento previo. Los resultados se presentarán de manera agregada, garantizando el anonimato de los participantes. Usted tiene derecho a acceder, rectificar o eliminar sus datos en cualquier momento contactando al administrador de la encuesta. La participación es voluntaria y puede abandonar la encuesta en cualquier momento sin consecuencias. Al continuar, confirma que ha leído y acepta estas políticas de privacidad y el tratamiento de sus datos personales conforme a lo aquí establecido.',
  );
  const [declineMessage, setDeclineMessage] = useState({
    title: '¿Estás seguro?',
    message:
      'Si no aceptas las políticas de privacidad, no podrás continuar con la encuesta. ¿Deseas continuar sin aceptar?',
    buttonAcceptText: 'Sí, rechazar',
    buttonDeclineText: 'Cancelar',
  });
  const [responseLimitEnabled, setResponseLimitEnabled] = useState(false);
  const [maxResponses, setMaxResponses] = useState(100);
  //const [limitType2, setLimitType2] = useState("total");
  /*const [limitReachedMessage, setLimitReachedMessage] = useState({
    title: "Encuesta cerrada",
    message:
      "Esta encuesta ha alcanzado el número máximo de respuestas permitidas",
    secondaryMessage: "Gracias por su interés en participar",
    buttonText: "Entendido",
  });*/
  const [urlError, setUrlError] = useState('');
  const [childQuestionNumber, setChildQuestionNumber] = useState([]);
  const [conditionalQuestion, setConditionalQuestion] = useState(false);
  const [categories, setCategories] = useState([]);
  const [categoryId, setCategoryId] = useState(null);
  const [categoryError, setCategoryError] = useState('');
  const [customOptionError, setCustomOptionError] = useState([]);
  const [optionRelationalError, setOptionRelationalError] = useState([]);
  const currentCompany = useSelector((state) => state.companies.currentCompany);
  const [question, setQuestion] = useState();
  const [anonymous, setAnonymous] = useState(false);
  const [isCompletedAnonymous, setIsCompletedAnonymous] = useState(false); // "" | "anonima"
  const [view360, setView360] = useState([]);
  const [isView360, setIsView360] = useState(false);
  const [excelFile360, setExcelFile360] = useState(null);
  const [selectedFileSelectQuestion, setSelectedFileSelectQuestion] =
    useState(null);

  const [exclusiviness, setExclusiviness] = useState(true);
  // Fechas programadas, solo informativas. Vacío = sin fecha programada.
  const [startDate, setStartDate] = useState(null);
  const [closingDate, setClosingDate] = useState(null);
  // No se deja guardar una encuesta que termina antes de empezar.
  const fechasInvalidas = finAntesDeInicio(startDate, closingDate);
  const [openMailBox, setOpenMailBox] = useState(false);
  const [haveEvaAgents, setHaveEvaAgents] = useState(false);
  const [reportConfigurationIds, setReportConfigurationIds] = useState([]);
  const [haveReportPDF, setHaveReportPDF] = useState(false);

  const [hasWhatsApp, setHasWhatsApp] = useState(false);
  const [dayConcurrency, setDayConcurrency] = useState(1);
  const [isAMultiAnswerSurvey, setIsAMultiAnswerSurvey] = useState(false);
  const [checkForm, setCheckForm] = useState(false);
  const [newDemographics, setNewDemographics] = useState([]);
  const [loading, setLoading] = useState(false);
  const [templateDemographics, setTemplateDemographics] = useState([]);
  const [mapsLoaded, setMapsLoaded] = useState(false);
  const [surveyMessages, setSurveyMessages] = useState({
    welcomeMessage: 'Ingrese su correo electrónico o cédula para continuar',
    inputMessage: 'Correo electrónico o cédula',
    confidentialityMessage:
      'Tus respuestas serán completamente confidenciales y no podrán ser vinculadas a tu identidad.',
  });
  const [surveyOpenMailBoxMessages, setSurveyOpenMailBoxMessages] = useState({
    inputMessage: 'Celular o cédula',
    isRequeridMailBoxInput: false,
  });
  const [questionsPerPage, setQuestionsPerPage] = useState(3);
  const [primaryColor, setPrimaryColor] = useState('#03aae4');
  const [secondaryColor, setSecondaryColor] = useState('#f3f3f3');
  const [textTypeGenericInput, setTextTypeGenericInput] = useState('text');
  const [hasNumerationNumber, setHasNumerationNumber] = useState(true);
  const [errorDayConcurrency, setErrorDayConcurrency] = useState(false);
  const [isUploadingFile, setIsUploadingFile] = useState(false);
  const [includeLogo, setIncludeLogo] = useState(false);
  const [saveOption, setSaveOption] = useState(false);
  const { enqueueSnackbar } = useSnackbar();
  const isMap = searchParams.get('isMap') === 'true';
  const isEdit = searchParams.get('isEdit') === 'true';
  const isTemplate =
    searchParams.get('isTemplate') === 'true' ||
    location.pathname.indexOf('journey/update-template') !== -1;
  const isUpdate = location.pathname.indexOf('journey/update-template') !== -1;
  const templateId =
    searchParams.get('templateId') || location.pathname.split('/')[3];
  const [demographics, setDemographics] = useState([]);
  const [bannerImage, setBannerImage] = useState(null);
  const [backgroundImage, setBackgroundImage] = useState(null);
  const [scrollToQuestionId, setScrollToQuestionId] = useState(null);
  const [questionIdDelete, setQuestionIdDelete] = useState([]);
  const originalQuestionsRef = useRef([]);
  const steps = isEdit
    ? [
        'Configuración',
        isCompletedAnonymous ? 'Mapa encuesta' : 'Configuración correo',
        'Encuesta',
      ]
    : getStepMapping();
  const [selectedFont, setSelectedFont] = useState('Roboto');
  const [checkboxLabel, setCheckboxLabel] = useState(
    'He leído las políticas de privacidad',
  );
  const [acceptButtonText, setAcceptButtonText] =
    useState('Acepto y continuar');
  const [declineButtonText, setDeclineButtonText] = useState(
    'No acepto y finalizar',
  );
  const [isEnabledIntroduction, setIsEnabledIntroduction] = useState(false);
  const [introductionText, setIntroductionText] = useState('');
  const introRef = useRef();
  const { surveyId } = useParams();

  /**
   * Handle introduction change.
   *
   * @param updatedData
   */
  const handleIntroductionChange = (updatedData) => {
    setData(updatedData);
  };

  //ENPS PROMOTE SQAURES
  const handleFirstSelectChange = (event) => {
    const value = parseInt(event.target.value, 10);
    setFirstSelect(value);

    // Cambiar automáticamente el segundo select dependiendo del primer select
    if (value === 0) {
      setSecondSelect(2);
    } else if (value === 1) {
      setSecondSelect(3);
    }
  };

  const handleSecondSelectChange = (event) => {
    setSecondSelect(event.target.value);
  };

  // Crear el rango dinámico basado en el primer select
  const startValue = firstSelect === 0 ? 2 : 3;
  const secondSelectOptions = Array.from(
    { length: 10 - startValue + 1 },
    (_, i) => startValue + i,
  );

  /**
   * Get demographics for create survey or template.
   *
   * @returns
   */
  const getDemographics = () => {
    const demographics = [];
    if (!data?.demographics) return [];
    data.demographics.forEach((demographic) => {
      const index = newDemographics.findIndex(
        (item) => item.name === demographic,
      );

      if (index !== -1) {
        demographics.push({
          name: newDemographics[index].name,
          options: newDemographics[index].options.map((option) => ({
            value: option,
            text: option,
          })),
        });
      } else {
        demographics.push({
          name: demographic,
          options: [],
        });
      }
    });
    return demographics;
  };

  const getScore = (question) => {
    if (question.typeId === 5) {
      return Array.isArray(question.stars)
        ? question.stars.length
        : question.stars || 3;
    } else if (question.typeId === 3 || question.typeId === 30) {
      return Number(question.stars);
    } else if (question.typeId === 19 || question.typeId === 24) {
      return Number(
        Array.isArray(question.stars) ? question.stars[0] : question.stars,
      );
    } else {
      return null;
    }
  };

  const getScore2 = (question) => {
    if (question.typeQuestionId === 5) {
      return question.score;
    } else if (question.typeQuestionId === 3) {
      return question.score.length;
    } else if (question.typeQuestionId === 30) {
      return question.score.length;
    } else if (
      question.typeQuestionId === 19 ||
      question.typeQuestionId === 24
    ) {
      return Number(question.score.length);
    } else {
      return null;
    }
  };

  const updateDeclineMessage = (field, value) => {
    setDeclineMessage((prev) => ({
      ...prev,
      [field]: value,
    }));
  };
  /*const updateLimitReachedMessage = (field, value) => {
    setLimitReachedMessage((prev) => ({
      ...prev,
      [field]: value,
    }));
  };*/

  /**
   * Create survey.
   */
  const createSurvey = async () => {
    if (fechasInvalidas) {
      enqueueSnackbar('La fecha de fin no puede ser anterior a la fecha de inicio.', {
        variant: 'error',
      });
      return;
    }
    setLoading(true);
    if (errorDayConcurrency || dayConcurrency === '') return;
    const composedMap = {};

    await Promise.all(
      questions.map(async (q) => {
        if (q.relatedQuestionId) {
          if (!composedMap[q.relatedQuestionId]) {
            composedMap[q.relatedQuestionId] = [];
          }
          composedMap[q.relatedQuestionId].push(q.id);
        }

        if (q.multimedia && typeof q.multimedia === 'object') {
          const isImage = q.multimedia.type === 'image';
          const isVideo = q.multimedia.type === 'video';

          if (isImage || isVideo) {
            try {
              const formData = new FormData();

              formData.append('surveyId', '1');
              formData.append('questionId', q.id);

              // Asumiendo que el archivo está en .file
              if (q.multimedia.urlMedia) {
                const response = await fetch(q.multimedia.urlMedia);
                const blob = await response.blob();

                // Opcional: usar el nombre del archivo si lo tienes
                const file = new File(
                  [blob],
                  q.multimedia.fileName || 'archivo.bin',
                  {
                    type: blob.type,
                  },
                );

                formData.append('file', file);
              }

              const response = await client.post(
                '/upload/file/question',
                formData,
                {
                  headers: {
                    'Content-Type': 'multipart/form-data',
                  },
                },
              );

              const multimedia = {
                type: q.multimedia.type,
                urlMedia: response.data.url,
              };
              q.multimedia = multimedia;
            } catch (error) {
              console.error('Error en la subida de multimedia:', error);
            }
          }
        }
      }),
    );
    const newSurvey = {
      includeLogo: includeLogo,
      ReportConfigurationIds: haveEvaAgents ? reportConfigurationIds : [],
      survey: {
        policyPrivacySettings: {
          checkboxText: checkboxLabel,
          dataPrivacyPolicyUrl: privacyPolicyEnabled
            ? dataPrivacyPolicyUrl
            : '',
          dataPrivacyPolicyText: privacyPolicyEnabled
            ? dataPrivacyPolicyText
            : '',
          isPrivacyPolicyEnabled: privacyPolicyEnabled,
          buttonAceotText: acceptButtonText,
          buttonDeclineText: declineButtonText,
          declineMessage: {
            title: declineMessage.title,
            message: declineMessage.message,
            ButtonAcceptText: declineMessage.buttonAcceptText,
            ButtonDeclineText: declineMessage.buttonDeclineText,
          },
        },
        maxAnswer: responseLimitEnabled ? maxResponses : 0,
        HaveUser: isCompletedAnonymous,
        pagination: questionsPerPage,
        HaveReportPDF: haveReportPDF,
        haveAnalysis: haveEvaAgents,
        nameSurvey: data?.title || '',
        descriptionSurvey: data?.description || '',
        messageMail: data?.mailingMessage || '',
        emailSubject: data?.emailSubject || '',
        emailMask: data?.emailMask || '',
        isPersonal: anonymous,
        answerDate: closingDate ? closingDate.toISOString() : null,
        startDate: startDate ? startDate.toISOString() : null,
        exclusive: exclusiviness,
        isBuzon: openMailBox,
        requiredInputMailBox: surveyOpenMailBoxMessages.inputMessage,
        mapId: data.map.id,
        companyId: currentCompany.id,
        wellcomeMessage: surveyMessages.welcomeMessage,
        inputMessage: surveyMessages.inputMessage,
        confindencialityMessage: surveyMessages.confidentialityMessage,
        duplicateResponses: isAMultiAnswerSurvey,
        daysConcurrency: dayConcurrency,
        hasWhatsApp: hasWhatsApp,
        hasNumerationNumber: hasNumerationNumber,
        is360Survey: isView360,
        saveOption: saveOption,
        fontFamily: selectedFont ?? 'Roboto',
        settings: {
          primaryColor: primaryColor,
          secondaryColor: secondaryColor,
          textType: textTypeGenericInput,
          introductionText: introductionText,
          hasIntroduction: isEnabledIntroduction,
        },
      },
      questions: questions.map((question) => ({
        question: {
          nameQuestion: question.name,
          description: question.description,
          typeQuestionId: question.typeId,
          score: getScore(question),
          conditional: question.conditionalQuestion,
          textsBipolarBar: question.textsBipolarBar,
          autoValidate: question.autoValidate,
          required: question.isRequired,
          NeedSentimentalAnalisys: question.needSentimentalAnalisys,
          ...(question.multimedia
            ? {
                multimedia: {
                  type: question.multimedia.type,
                  urlMedia: question.multimedia.urlMedia,
                },
              }
            : {}),
          ...(question.typeId === 30
            ? {
                maxFiles: question?.limitOptions ?? 1,
              }
            : {}),
          ...(question.tableSetting?.options && {
            tableSetting: {
              options: question.tableSetting.options,
            },
          }),
          matrixOption:
            question.matrixOption &&
            (question.matrixOption.options?.length > 0 ||
              question.matrixOption.values?.length > 0)
              ? question.matrixOption
              : null,
          ...(question.parentId
            ? { complexChildQuestionId: question.parentId }
            : {}),
          ...(question.typeId == 26 ? { complexParentId: question.id } : {}),
          ...(question.typeId === 1 || question.typeId === 27
            ? {
                settings: {
                  microphoneEnabled: question?.voiceEnabled ?? true,
                  responseTimeoutSeconds: question?.voiceDuration ?? 60,
                  textType: question?.validationType ?? 'text',
                  wordSizeLimit: question?.wordSizeLimit ?? 500,
                  haveLimit: question?.haveLimit ?? true,
                  limitOptions: question?.limitOptions ?? 1,
                },
              }
            : {}),
        },
        options: question.customOptions?.map((option, index) => {
          const processedOption = processOption(option, index);
          return {
            optionsName: processedOption.optionsName,
            numberOption: processedOption.numberOption,
            questionChildren: question.childQuestionIds?.[index] || '',
            ...(processedOption.isOther && { isOther: true }), // Solo añadir isOther si existe
          };
        }),
        selectOptions: question.selectOptions?.map((option, index) => {
          return {
            nameSelectOption: option,
          };
        }),
        categoryId: question.categoryId,
      })),
      //demographics: getDemographics(),
      demographic: demographics,
    };
    const { data: createdJourney } = await client.post(
      `/createJourney/${currentCompany.id}`,
      newSurvey,
    );
    let urlBackground = null,
      urlBanner = null;

    if (backgroundImage || bannerImage) {
      try {
        const formData = new FormData();
        formData.append('SurveyId', createdJourney.id);
        // Solo agregar los archivos que existen
        if (backgroundImage) {
          formData.append('backgroundImage', backgroundImage);
        }
        if (bannerImage) {
          formData.append('bannerImage', bannerImage);
        }

        const response = await client.post(
          '/upload/file/background',
          formData,
          {
            headers: {
              'Content-Type': 'multipart/form-data',
            },
          },
        );

        // Acceder a response.data (típico en axios)
        urlBackground = response.data?.backgroundUrl || null;
        urlBanner = response.data?.bannerUrl || null;
      } catch (error) {
        console.error('Error en la subida de multimedia:', error);
        // Opcional: mostrar mensaje de error al usuario
      }
    }
    if (isView360) {
      const payload = {
        surveyId: createdJourney.id,
        evaluators: view360,
      };

      await client.post('/Evaluators', payload);
    }

    setLoading(false);
    navigate(`/journey/survey/${createdJourney.id}/detail?sendMail=true`);
    enqueueSnackbar('Cuestionario creado con éxito', {
      variant: 'success',
    });
  };
  /**
   * Edit survey.
   */
  const editSurvey = async () => {
    if (fechasInvalidas) {
      enqueueSnackbar('La fecha de fin no puede ser anterior a la fecha de inicio.', {
        variant: 'error',
      });
      return;
    }
    setLoading(true);
    let urlBackground =
      typeof backgroundImage === 'string' ? backgroundImage : null;
    let urlBanner = typeof bannerImage === 'string' ? bannerImage : null;

    // Si alguno es File, subirlos
    if (backgroundImage instanceof File || bannerImage instanceof File) {
      try {
        const formData = new FormData();
        formData.append('SurveyId', surveyId);

        if (backgroundImage instanceof File) {
          formData.append('backgroundImage', backgroundImage);
        }
        if (bannerImage instanceof File) {
          formData.append('bannerImage', bannerImage);
        }

        const response = await client.post(
          '/upload/file/background',
          formData,
          {
            headers: {
              'Content-Type': 'multipart/form-data',
            },
          },
        );

        // Sobrescribir con las URLs del backend
        if (response.data) {
          urlBackground = response.data.backgroundUrl || urlBackground;
          urlBanner = response.data.bannerUrl || urlBanner;
        }
      } catch (error) {
        console.error('Error en la subida de multimedia:', error);
        // Aquí podrías usar tu snackbar
      }
    }
    const payload = {
      surveyId: surveyId,
      surveyName: data?.title ?? '',
      descriptionSurvey: data?.description ?? '',
      messageMail: data?.mailingMessage ?? '',
      emailSubject: data?.emailSubject ?? '',
      emailmask: data?.emailMask ?? '',
      welcomeMessage: surveyMessages?.welcomeMessage ?? null,
      inputMessage: surveyMessages?.inputMessage ?? null,
      confindencialityMessage: surveyMessages?.confidentialityMessage ?? null,
      hasNumerationNumber: hasNumerationNumber,
      includeLogo: includeLogo,
      pagination: questionsPerPage,
      maxAnswer: responseLimitEnabled ? maxResponses : 0,
      requiredInputMailBox: surveyOpenMailBoxMessages.inputMessage,
      isBuzon: openMailBox,
      hasWhatsApp: hasWhatsApp,
      exclusive: isCompletedAnonymous ? false : exclusiviness,
      answerDate: closingDate ? closingDate.toISOString() : null,
      startDate: startDate ? startDate.toISOString() : null,
      saveOption: saveOption,
      policyPrivacySettings: {
        checkboxText: checkboxLabel,
        dataPrivacyPolicyUrl: privacyPolicyEnabled
          ? dataPrivacyPolicyUrl
          : null,
        dataPrivacyPolicyText: privacyPolicyEnabled
          ? dataPrivacyPolicyText
          : '',
        isPrivacyPolicyEnabled: privacyPolicyEnabled,
        buttonAceotText: acceptButtonText,
        buttonDeclineText: declineButtonText,
        declineMessage: {
          title: declineMessage.title,
          message: declineMessage.message,
          ButtonAcceptText: declineMessage.buttonAcceptText,
          ButtonDeclineText: declineMessage.buttonDeclineText,
        },
      },

      fontFamily: selectedFont ?? 'Roboto',
      settings: {
        primaryColor: primaryColor ?? null,
        secondaryColor: secondaryColor ?? null,
        urlBanner: urlBanner ?? null,
        urlBackground: urlBackground ?? null,
        textType: textTypeGenericInput ?? null,
        hasIntroduction: isEnabledIntroduction ?? null,
        introductionText: introductionText ?? null,
      },
      reportConfigurationIds : haveEvaAgents ? reportConfigurationIds : [],
      haveReportPdf: haveReportPDF,
      haveAnalysis: haveEvaAgents,
    };

    await client.put('/SurveyMessages', payload);
    const composedMap = {};
    await Promise.all(
      questions.map(async (q) => {
        if (q.relatedQuestionId) {
          if (!composedMap[q.relatedQuestionId]) {
            composedMap[q.relatedQuestionId] = [];
          }
          composedMap[q.relatedQuestionId].push(q.id);
        }

        // 1. Subir multimedia primero si existe
        if (q.multimedia && typeof q.multimedia === 'object') {
          const isImage = q.multimedia.type === 'image';
          const isVideo = q.multimedia.type === 'video';

          if (isImage || isVideo) {
            try {
              const formData = new FormData();
              formData.append('surveyId', '1');
              formData.append('questionId', q.id);

              if (q.multimedia.urlMedia) {
                const response = await fetch(q.multimedia.urlMedia);
                const blob = await response.blob();
                const file = new File(
                  [blob],
                  q.multimedia.fileName || 'archivo.bin',
                  { type: blob.type },
                );
                formData.append('file', file);
              }

              const response = await client.post(
                '/upload/file/question',
                formData,
                {
                  headers: { 'Content-Type': 'multipart/form-data' },
                },
              );

              q.multimedia = {
                type: q.multimedia.type,
                urlMedia: response.data.url, // ✅ URL ya actualizada antes del payload
              };
            } catch (error) {
              console.error('Error en la subida de multimedia:', error);
            }
          }
        }
        // 2. Armar y enviar payload con multimedia ya actualizado
        const payload = {
          question: {
            numberQuestion: q.questionNumber,
            questionId: q.questionId ?? 0,
            nameQuestion: q.name,
            description: q.description,
            typeQuestionId: q.typeId,
            score: getScore(q),
            conditional: q.conditionalQuestion,
            textsBipolarBar: q.textsBipolarBar,
            autoValidate: q.autoValidate,
            required: q.isRequired,
            NeedSentimentalAnalisys: q.needSentimentalAnalisys,
            ...(q.multimedia
              ? {
                  multimedia: {
                    type: q.multimedia.type,
                    urlMedia: q.multimedia.urlMedia,
                  },
                }
              : {}),
            ...(q.typeId === 30 ? { maxFiles: q?.limitOptions ?? 1 } : {}),
            ...(q.tableSetting?.options && {
              tableSetting: { options: q.tableSetting.options },
            }),
            matrixOption:
              q.matrixOption &&
              (q.matrixOption.options?.length > 0 ||
                q.matrixOption.values?.length > 0)
                ? q.matrixOption
                : null,
            ...(q.parentId ? { complexChildQuestionId: q.parentId } : {}),
            ...(q.typeId == 26 ? { complexParentId: q.id } : {}),
            ...(q.typeId === 1 || q.typeId === 27
              ? {
                  settings: {
                    microphoneEnabled: q?.voiceEnabled ?? true,
                    responseTimeoutSeconds: q?.voiceDuration ?? 60,
                    textType: q?.validationType ?? 'text',
                    wordSizeLimit: q?.wordSizeLimit ?? 500,
                    haveLimit: q?.haveLimit ?? true,
                    limitOptions: q?.limitOptions ?? 1,
                  },
                }
              : {}),
          },
          options: q.customOptions?.map((option, index) => {
            const processedOption = processOption(option, index);
            return {
              optionsName: processedOption.optionsName,
              numberOption: processedOption.numberOption,
              id: q.questionOptions?.[index]?.id ?? 0,
              questionChildren:
                q.childQuestionIds?.[index] ??
                q.questionOptions?.[index]?.questionChildren ??
                '',
              ...(processedOption.isOther && { isOther: true }),
            };
          }),
          selectOptions: q.selectOptions?.map((option) => ({
            nameSelectOption: option,
          })),
          ...(q.typeId !== 21 && { categoryId: q.categoryId }),
        };

        if (payload.question.questionId) {
          await client.put(`/Question/${surveyId}`, payload);
        } else {
          await client.post(`/Question/${surveyId}`, payload);
        }
      }),
    );

    // 3. Demographics al final, una sola vez
    await client.put(`/update-demographics/${surveyId}`, demographics);

    //Delete Questions
    if (
      questionIdDelete.questionIds &&
      questionIdDelete.questionIds.length > 0
    ) {
      await client.delete(`/Question/${surveyId}`, {
        data: questionIdDelete,
      });
    }

    setLoading(false);
    navigate(`/journey/survey/${surveyId}/detail`);
    enqueueSnackbar('Cuestionario editado con éxito', {
      variant: 'success',
    });
  };

  /**
   * Create survey template.
   */
  const createTemplate = async () => {
    setLoading(true);
    // Create survey, encuesta de mapa
    const newTemplate = {
      mapId: data.map.id,
      nameSurvey: data.title,
      descriptionSurvey: data.description,
      messageMail: data.mailingMessage,
      emailSubject: data.emailSubject,
      emailMask: data.emailMask,
      settings: {
        primaryColor: primaryColor,
        secondaryColor: secondaryColor,
      },
      isObligatory: !(data.surveyOrMap === 'survey'),
      questionSection: questions.map((question, index) => ({
        templateCategoryId: question.categoryId,
        templateQuestion: {
          nameQuestion: question.name,
          numberQuestion: index + 1,
          score: question.stars?.length,
          typeQuestionId: question.typeId,
          description: question.description,
        },
        templateOption: question.customOptions?.map((option, index) => {
          const processedOption = processOption(option, index);
          return {
            templateOptionsName: processedOption.optionsName,
            numberOption: processedOption.numberOption,
            ...(processedOption.isOther && { isOther: true }), // Solo añadir isOther si existe
          };
        }),
      })),
      demographics: getDemographics().map((demographic) => ({
        name: demographic.value || demographic.name,
        options: demographic.options.map((option) => ({
          value: option.value,
          text: option.text,
        })),
      })),
    };
    const resourceName =
      data.surveyOrMap === 'survey' ? 'Plantilla' : 'Ruta de mapa';
    await client.post(
      `Administrator/createTemplate/${currentCompany.id}`,
      newTemplate,
    );

    setLoading(false);
    navigate(`/journeysettings?tab=${data.surveyOrMap}`);
    enqueueSnackbar(`${resourceName} creada con éxito`, {
      variant: 'success',
    });
  };

  /**
   * Update template.
   */
  const updateTemplate = async () => {
    setLoading(true);

    const body = {
      id: templateId,
      nameSurvey: data.title,
      descriptionSurvey: data.description,
      messagemail: data.mailingMessage,
      isObligatory: false,
      journeyMapId: data.map.id,
    };

    try {
      await updateTemplateAPI(templateId, body);
    } catch (e) {}

    setLoading(false);
  };

  const validateLengthQuestion = (questions) => {
    if (questions.length === 0) {
      enqueueSnackbar('La encuesta debe tener al menos una pregunta.', {
        variant: 'error',
        autoHideDuration: 3000,
      });
      return true;
    }
  };

  const validateMultipleQuestion = (questions) => {
    for (const question of questions) {
      if (question.typeId == 3 || question.typeId == 8) {
        const allEmpty = question.customOptions.every(
          (opt) => !opt.value || opt.value.trim() === '',
        );
        if (allEmpty) {
          enqueueSnackbar(
            `Debes agregar al menos una opción válida. A la pregunta Q${question.questionNumber}`,
            { variant: 'error', autoHideDuration: 3000 },
          );
          return question.id; // ✅ Retornar ID en lugar de true
        }
      }

      if (question.typeId === 15) {
        const allCustomEmpty =
          !question.customOptions ||
          question.customOptions.every(
            (opt) => !opt.value || opt.value.trim() === '',
          );

        const allSelectEmpty =
          !question.selectOptions ||
          question.selectOptions.every(
            (opt) => !opt.value || opt.value.trim() === '',
          );

        if (allCustomEmpty && allSelectEmpty) {
          enqueueSnackbar(
            `Debes agregar al menos una opción válida en la pregunta: Q${question.questionNumber}`,
            { variant: 'error', autoHideDuration: 3000 },
          );
          return question.id; // ✅ Retornar ID
        }
      }

      if (question.typeId === 19) {
        const { stars, textsBipolarBar } = question;
        const starsInvalid = stars === '0' || stars === 0;
        const leftEmpty =
          !textsBipolarBar.leftText || textsBipolarBar.leftText.trim() === '';
        const rightEmpty =
          !textsBipolarBar.rightText || textsBipolarBar.rightText.trim() === '';

        if (starsInvalid || leftEmpty || rightEmpty) {
          enqueueSnackbar(
            `Debes configurar correctamente la pregunta Q${question.questionNumber}`,
            { variant: 'error', autoHideDuration: 3000 },
          );
          return question.id; // ✅ Retornar ID
        }
      }

      if (question.typeId === 22) {
        const { textsBipolarBar } = question;
        const leftEmpty =
          !textsBipolarBar.leftText || textsBipolarBar.leftText.trim() === '';
        const rightEmpty =
          !textsBipolarBar.rightText || textsBipolarBar.rightText.trim() === '';

        if (leftEmpty || rightEmpty) {
          enqueueSnackbar(
            `Debes configurar correctamente la pregunta Q${question.questionNumber}`,
            { variant: 'error', autoHideDuration: 3000 },
          );
          return question.id; // ✅ Retornar ID
        }
      }

      if (question.typeId === 24) {
        const { customOptions, stars } = question;
        const allCustomEmpty =
          !customOptions ||
          customOptions.every((opt) => !opt.value || opt.value.trim() === '');
        const starsInvalid = stars === '0' || stars === 0;

        if (allCustomEmpty || starsInvalid) {
          enqueueSnackbar(
            `Debes configurar correctamente la pregunta Q${question.questionNumber}`,
            { variant: 'error', autoHideDuration: 3000 },
          );
          return question.id; // ✅ Retornar ID
        }
      }

      if (question.typeId === 25) {
        const rows = question.matrixOption?.options || [];
        const columns = question.matrixOption?.values || [];
        const isDynamic = question.matrixOption?.matrixType === 'dynamic';

        if (isDynamic) {
          const dynamicOptions = question.matrixOption?.options || [];
          const nonEmptyOptions = dynamicOptions.filter(
            (opt) => opt && opt.toString().trim() !== '',
          );
          const isExcelEmpty = nonEmptyOptions.length === 0;

          if (isExcelEmpty) {
            enqueueSnackbar(
              `Debes completar correctamente la matriz en la pregunta Q${question.questionNumber}`,
              { variant: 'error', autoHideDuration: 3000 },
            );
            return question.id; // ✅ Retornar ID
          }
        }

        if (!isDynamic) {
          const hasEmptyRow =
            rows.length === 0 || rows.some((row) => !row || row.trim() === '');
          const hasEmptyColumn =
            columns.length === 0 ||
            columns.some((col) => !col || col.trim() === '');

          if (hasEmptyRow || hasEmptyColumn) {
            enqueueSnackbar(
              `Debes completar correctamente la matriz en la pregunta Q${question.questionNumber}`,
              { variant: 'error', autoHideDuration: 3000 },
            );
            return question.id; // ✅ Retornar ID
          }
        }
      }
      if (question.typeId === 29) {
        const tableOptions = question.tableSetting?.options || [];

        if (tableOptions.length === 0) {
          enqueueSnackbar(
            `Debes agregar al menos una columna en la pregunta Q${question.questionNumber}`,
            { variant: 'error', autoHideDuration: 3000 },
          );
          return question.id;
        }

        const hasEmptyColumn = tableOptions.some(
          (col) => !col.value || col.value.trim() === '',
        );

        if (hasEmptyColumn) {
          enqueueSnackbar(
            `Todas las columnas deben tener nombre en la pregunta Q${question.questionNumber}`,
            { variant: 'error', autoHideDuration: 3000 },
          );
          return question.id;
        }
      }
      if (question.typeId === 30) {
        const allowedTypes = (question.customOptions || [])
          .map((opt) => (typeof opt === 'string' ? opt : opt?.value))
          .filter((v) => v && v.trim() !== '');

        if (allowedTypes.length === 0) {
          enqueueSnackbar(
            `Debes seleccionar al menos un tipo de archivo en la pregunta Q${question.questionNumber}`,
            { variant: 'error', autoHideDuration: 3000 },
          );
          return question.id;
        }
      }
    }

    return null; // ✅ Retornar null si no hay errores
  };

  const validateFileQuestions = (questions) => {
    const missingFileQuestions = questions.filter(
      (q) => [26, 27].includes(q.typeId) && !q.file && !q.customOptions?.length,
    );

    if (missingFileQuestions.length > 0) {
      missingFileQuestions.forEach((q) => {
        enqueueSnackbar(
          `La pregunta "Q${
            q.questionNumber || 'sin nombre'
          }" requiere un archivo de Excel`,
          { variant: 'error', autoHideDuration: 3000 },
        );
      });
      return missingFileQuestions[0].id; // ✅ Retornar el ID de la primera pregunta con error
    }

    return null; // ✅ Retornar null si no hay errores
  };

  const validateCategoryForQuestions = (questions) => {
    const invalidQuestions = questions
      .map((question, index) => ({
        ...question,
        originalIndex: index + 1,
      }))
      .filter((question) => {
        if (question.typeId === 21) return false;
        if (question.categoryId === null || question.categoryId === undefined)
          return true;
        // ← Verificar que el ID exista en el catálogo
        const exists = categories.some((c) => c.id === question.categoryId);
        return !exists;
      });

    if (invalidQuestions.length > 0) {
      invalidQuestions.forEach((question) => {
        enqueueSnackbar(
          `La pregunta # ${question.originalIndex} no tiene categoría`,
          { variant: 'error', autoHideDuration: 3000 },
        );
      });
      return invalidQuestions[0].id; // ✅ Retornar el ID de la primera pregunta con error
    }

    return null; // ✅ Retornar null si no hay errores
  };

  const validateCompositeQuestions = (questions) => {
    const compuestas = questions.filter((q) => q.typeId === 26);
    const errors = [];

    compuestas.forEach((compuesta) => {
      const hijos = questions.filter((q) => q.parentId === compuesta.id);
      if (hijos.length === 0) {
        errors.push(compuesta);
      }
    });

    if (errors.length > 0) {
      enqueueSnackbar(
        `Las siguientes preguntas compuestas no tienen hijas: ${errors
          .map((e) => e.name)
          .join(', ')}`,
        { variant: 'error' },
      );
      return errors[0].id; // ✅ Retornar el ID de la primera pregunta con error
    }

    return null; // ✅ Retornar null si no hay errores
  };

  const validateMultimediaQuestions = (questions) => {
    const invalidMultimediaQuestions = questions.filter((q) => {
      if (q.typeId !== 28) return false;

      if (!q.multimedia?.type || !q.multimedia?.urlMedia) {
        return true;
      }

      if (
        q.multimedia.type === 'youtube' &&
        (typeof q.multimedia.urlMedia !== 'string' ||
          !validateYouTubeUrl(q.multimedia.urlMedia))
      ) {
        return true;
      }

      return false;
    });

    if (invalidMultimediaQuestions.length > 0) {
      invalidMultimediaQuestions.forEach((q) => {
        let errorMessage = '';

        if (!q.multimedia?.type || !q.multimedia?.urlMedia) {
          errorMessage = `La pregunta "Q${
            q.questionNumber || 'sin nombre'
          }" requiere multimedia`;
        } else if (
          q.multimedia.type === 'youtube' &&
          (typeof q.multimedia.urlMedia !== 'string' ||
            !validateYouTubeUrl(q.multimedia.urlMedia))
        ) {
          errorMessage = `La pregunta "Q${
            q.questionNumber || 'sin nombre'
          }" tiene URL inválida`;
        }

        enqueueSnackbar(errorMessage, {
          variant: 'error',
          autoHideDuration: 3000,
        });
      });

      return invalidMultimediaQuestions[0].id; // ✅ Retornar el ID de la primera pregunta con error
    }

    return null; // ✅ Retornar null si no hay errores
  };

  const validateExcelFile360 = () => {
    if (!excelFile360 && isView360) {
      enqueueSnackbar('Debe ingresar el archivo 360.', {
        variant: 'error',
        autoHideDuration: 3000,
      });
      return true;
    }
  };

  const getQuestionTypeName = (surveyQuestion) => {
    const questionTypeId = Number(
      surveyQuestion.typeId ?? surveyQuestion.typeQuestionId,
    );
    const questionType = questionTypes.find((q) => q.id === questionTypeId);

    return (
      surveyQuestion.type ||
      surveyQuestion.typeQuestion ||
      questionType?.typeQuestionName ||
      `Tipo ${questionTypeId}`
    );
  };

  const getWhatsAppIncompatibleQuestions = (surveyQuestions = questions) =>
    surveyQuestions.filter((surveyQuestion) => {
      const questionTypeId = Number(
        surveyQuestion.typeId ?? surveyQuestion.typeQuestionId,
      );

      return !WHATSAPP_QUESTION_TYPE_IDS.includes(questionTypeId);
    });

  const showWhatsAppIncompatibleWarning = (surveyQuestions = questions) => {
    const incompatibleQuestions =
      getWhatsAppIncompatibleQuestions(surveyQuestions);

    if (incompatibleQuestions.length === 0) {
      return incompatibleQuestions;
    }

    const incompatibleTypes = [
      ...new Set(incompatibleQuestions.map(getQuestionTypeName)),
    ];
    const visibleTypes = incompatibleTypes.slice(0, 4).join(', ');
    const remainingTypes = incompatibleTypes.length - 4;

    enqueueSnackbar(
      `No puedes activar WhatsApp porque la encuesta tiene preguntas no compatibles: ${visibleTypes}${
        remainingTypes > 0 ? ` y ${remainingTypes} más` : ''
      }.`,
      {
        variant: 'warning',
        autoHideDuration: 5000,
      },
    );

    return incompatibleQuestions;
  };

  /**
   * Handle next step.
   */

  const handleNextStep = async () => {
    if (isEdit) {
      // Lógica simple para modo edición
      switch (activeStep) {
        case 0:
          setActiveStep(1);
          return;
        case 1:
          setActiveStep(2);
          return;
        case 2:
          if (validateLengthQuestion(questions)) return;

          const errorCat = validateCategoryForQuestions(questions);
          if (errorCat) {
            setScrollToQuestionId(errorCat);
            return;
          }

          const errorMultiple = validateMultipleQuestion(questions);
          if (errorMultiple) {
            setScrollToQuestionId(errorMultiple);
            return;
          }

          const errorComposite = validateCompositeQuestions(questions);
          if (errorComposite) {
            setScrollToQuestionId(errorComposite);
            return;
          }

          const errorFile = validateFileQuestions(questions);
          if (errorFile) {
            setScrollToQuestionId(errorFile);
            return;
          }

          const errorMultimedia = validateMultimediaQuestions(questions);
          if (errorMultimedia) {
            setScrollToQuestionId(errorMultimedia);
            return;
          }

          if (hasWhatsApp) {
            const incompatibleQuestions = showWhatsAppIncompatibleWarning();

            if (incompatibleQuestions.length > 0) {
              setScrollToQuestionId(incompatibleQuestions[0].id);
              return;
            }
          }

          editSurvey();
          return;
        default:
          setActiveStep(0);
      }
      return;
    }

    // Para modo creación, usar la misma lógica de mapeo
    const stepLabels = getStepMapping();
    const currentStepLabel = stepLabels[activeStep];
    const isLastStep = activeStep === stepLabels.length - 1;

    switch (currentStepLabel) {
      case 'Tipo Encuesta':
        if (validateExcelFile360()) {
          return;
        }
        setActiveStep(activeStep + 1);
        break;

      case 'Privacidad':
      case 'Configuración':
        if (
          privacyPolicyEnabled &&
          dataPrivacyPolicyUrl &&
          !isValidUrl(dataPrivacyPolicyUrl)
        ) {
          setUrlError('Ingrese una URL válida (ej: https://ejemplo.com)');
          return;
        }
      case 'Concurrencia':
      case 'Auto Guardado':
        setActiveStep(activeStep + 1);
        break;
      case 'Mapa encuesta':
        const isValidMap = introRef.current?.validateForm?.();
        if (!isValidMap) return;
        const mapFormData = introRef.current?.getFormData?.();
        if (mapFormData) setData(mapFormData);
        setActiveStep(activeStep + 1);
        break;
      case 'Configuración correo':
        const isValid = introRef.current?.validateForm?.();
        if (!isValid) return;
        const currentFormData = introRef.current?.getFormData?.();
        if (currentFormData) setData(currentFormData);
        setActiveStep(activeStep + 1);
        break;

      case 'Cuestionario':
        // Paso final
        if (isUpdate && isTemplate) {
          await updateTemplate();
          navigate('/journey/survey-template');
          enqueueSnackbar('Plantilla actualizada con éxito', {
            variant: 'success',
            autoHideDuration: 3000,
          });
          return;
        }

        if (isTemplate) {
          createTemplate();
          return;
        }

        // ✅ NUEVA LÓGICA: Capturar el ID de la pregunta con error
        let errorQuestionId = null;

        // Ejecutar todas las validaciones en orden
        if (validateLengthQuestion(questions)) {
          return; // Esta validación no tiene pregunta específica
        }

        errorQuestionId = validateCategoryForQuestions(questions);
        if (errorQuestionId) {
          setScrollToQuestionId(errorQuestionId);
          return;
        }

        errorQuestionId = validateMultipleQuestion(questions);
        if (errorQuestionId) {
          setScrollToQuestionId(errorQuestionId);
          return;
        }

        errorQuestionId = validateCompositeQuestions(questions);
        if (errorQuestionId) {
          setScrollToQuestionId(errorQuestionId);
          return;
        }

        errorQuestionId = validateFileQuestions(questions);
        if (errorQuestionId) {
          setScrollToQuestionId(errorQuestionId);
          return;
        }

        errorQuestionId = validateMultimediaQuestions(questions);
        if (errorQuestionId) {
          setScrollToQuestionId(errorQuestionId);
          return;
        }

        if (hasWhatsApp) {
          const incompatibleQuestions = showWhatsAppIncompatibleWarning();

          if (incompatibleQuestions.length > 0) {
            setScrollToQuestionId(incompatibleQuestions[0].id);
            return;
          }
        }

        createSurvey();
        break;

      default:
        setActiveStep(0);
    }
  };

  const handleCerrar = () => {
    if (activeStep === 0) {
      navigate('/journey');
    } else {
      setMapsLoaded(true);
      setActiveStep((val) => val - 1);
    }
  };

  /**
   * Handle change for current question.
   *
   * @param {object} event
   */
  const handleInformation = (event) => {
    const { name, value, type, checked } = event.target;

    if (name.includes('.')) {
      const [parentKey, childKey] = name.split('.');

      setInformation((prev) => {
        const updatedInfo = {
          ...prev,
          [parentKey]: {
            ...prev[parentKey],
            [childKey]: value,
          },
        };

        // Si estamos cambiando el valueLeft (el izquierdo)
        if (name === 'textsBipolarBar.valueLeft') {
          const start = value == '0' ? 2 : 3;
          updatedInfo.secondSelectOptions = Array.from(
            { length: 10 - start + 1 },
            (_, i) => (start + i).toString(), // <- aquí fuerza a string
          );
          // También reseteamos valueRight para que empiece correctamente
          updatedInfo.textsBipolarBar.valueRight = start.toString();
        }

        return updatedInfo;
      });
    } else {
      setInformation((prev) => {
        const newValue = type === 'checkbox' ? checked : value;

        const updated = {
          ...prev,
          [name]: newValue,
        };

        if (name === 'youtubeUrl') {
          const trimmedValue = newValue.trim();

          updated.multimedia = {
            type: trimmedValue === '' ? '' : 'youtube',
            urlMedia: newValue,
          };

          if (trimmedValue !== '') {
            updated.images = [];
            updated.videos = [];

            // Validar la URL mientras se escribe
            if (validateYouTubeUrl(trimmedValue)) {
              setErrorMessage((prev) => ({
                ...prev,
                multimedia: {
                  ...(prev.multimedia ?? {}),
                  youtube: false,
                },
              }));

              setHelperText((prev) => ({
                ...prev,
                multimedia: {
                  ...(prev.multimedia ?? {}),
                  youtubeMessage: '',
                },
              }));
            }
          } else {
            // Si está vacío, limpiar errores
            setErrorMessage((prev) => ({
              ...prev,
              multimedia: {
                ...(prev.multimedia ?? {}),
                youtube: false,
              },
            }));

            setHelperText((prev) => ({
              ...prev,
              multimedia: {
                ...(prev.multimedia ?? {}),
                youtubeMessage: '',
              },
            }));
          }
        }

        return updated;
      });
    }
  };

  /**
   * Handle change for category id.
   *
   * @param {number} categoryId The category id.
   */
  const handleCategoryIdChange = (categoryId) => {
    setCategoryId(categoryId);
  };
  const handleQuestion = (event) => {
    const { name, value, type, checked } = event.target;

    if (name.includes('.')) {
      const [parentKey, childKey] = name.split('.');

      setQuestion((prev) => {
        const updatedQuestion = {
          ...prev,
          [parentKey]: {
            ...prev[parentKey],
            [childKey]: type === 'checkbox' ? checked : value,
          },
        };

        // Lógica especial para textosBipolarBar.valueLeft
        if (name === 'textsBipolarBar.valueLeft') {
          const start = value == '0' ? 2 : 3;
          updatedQuestion.secondSelectOptions = Array.from(
            { length: 10 - start + 1 },
            (_, i) => (start + i).toString(),
          );
          updatedQuestion.textsBipolarBar.valueRight = start.toString();
        }

        return updatedQuestion;
      });
    } else {
      setQuestion((prev) => {
        const newValue = type === 'checkbox' ? checked : value;

        const updated = {
          ...prev,
          [name]: newValue,
        };

        if (name === 'youtubeUrl') {
          const trimmedValue = newValue.trim();

          updated.multimedia = {
            type: trimmedValue === '' ? '' : 'youtube',
            urlMedia: newValue,
          };

          if (trimmedValue !== '') {
            updated.images = [];
            updated.videos = [];

            // Validar la URL mientras se escribe
            if (validateYouTubeUrl(trimmedValue)) {
              setErrorMessage((prev) => ({
                ...prev,
                multimedia: {
                  ...(prev.multimedia ?? {}),
                  youtube: false,
                },
              }));

              setHelperText((prev) => ({
                ...prev,
                multimedia: {
                  ...(prev.multimedia ?? {}),
                  youtubeMessage: '',
                },
              }));
            }
          } else {
            // Si está vacío, limpiar errores
            setErrorMessage((prev) => ({
              ...prev,
              multimedia: {
                ...(prev.multimedia ?? {}),
                youtube: false,
              },
            }));

            setHelperText((prev) => ({
              ...prev,
              multimedia: {
                ...(prev.multimedia ?? {}),
                youtubeMessage: '',
              },
            }));
          }
        }

        return updated;
      });
    }
  };
  const updateQuestion = (id, data) => {
    setQuestion((prev) => ({
      ...prev,
      ...data,
    }));
  };

  const handleinformationoptions = (key) => (event) => {
    const holder = information.customOptions.map((val, index) => {
      if (index === key) {
        // Mantener la estructura del objeto, solo actualizar el valor
        return { ...val, value: event.target.value };
      } else return val;
    });
    setInformation({ ...information, customOptions: holder });
  };

  const processOption = (option, index) => {
    // Si es un objeto con propiedad isOther
    if (typeof option === 'object' && option !== null && 'value' in option) {
      if (option.isOther) {
        // Para opciones "Otro", mantener la estructura completa
        return {
          optionsName: option.value || 'Otro (especifique)',
          numberOption: index + 1,
          isOther: true,
          questionChildren: '',
        };
      } else {
        // Para opciones normales, solo el valor
        return {
          optionsName: option.value,
          numberOption: index + 1,
          questionChildren: '',
        };
      }
    }
    // Si es un string (compatibilidad hacia atrás)
    return {
      optionsName: option,
      numberOption: index + 1,
      questionChildren: '',
    };
  };

  const handleInformationRelationalOptions = (key) => (event) => {
    let holder = information.opcionesInputs.map((val, index) => {
      if (index === key) {
        return event.target.value;
      } else return val;
    });
    setInformation({ ...information, opcionesInputs: holder });
  };

  const handleInformationRelationalOptionsEdit = (key) => (event) => {
    let holder = question.selectOptions.map((val, index) => {
      if (index === key) {
        return event.target.value;
      } else return val;
    });
    setQuestion({ ...question, selectOptions: holder });
  };

  /**
   * Handle change for options.
   *
   * @param {ChangeEvent<HTMLInputElement>} event
   * @param {number} index The index of the option.
   * @param {boolean} isEdit If is edit.
   */
  const handleChangeOptions = (event, index, isEdit = false) => {
    if (isEdit) {
      setQuestion({
        ...question,
        options: question.options.map((option, i) => {
          if (i === index) {
            return event.target.value;
          }

          return option;
        }),
        customOptions: question.options.map((option, i) => {
          if (i === index) {
            return event.target.value;
          }

          return option;
        }),
      });

      return;
    }

    setInformation({
      ...information,
      options: information.options.map((option, i) => {
        if (i === index) {
          return event.target.value;
        }

        return option;
      }),
      customOptions: information.options.map((option, i) => {
        if (i === index) {
          return event.target.value;
        }

        return option;
      }),
    });
  };

  const handleeditoption = (key) => (event) => {
    let holder;
    holder = question.customOptions.map((val, i) => {
      if (i === key) {
        // CAMBIO: Mantener la estructura del objeto, solo actualizar el valor
        return { ...val, value: event.target.value };
      } else {
        return val;
      }
    });
    setQuestion({ ...question, customOptions: holder });
  };

  const handleaddstars = () => {
    if (information.stars.length === 10) {
      setStarmsg('Elija un valor entre 3 y 10');
    } else {
      setStarmsg('');
      let holder = [...information.stars];
      holder.push('');
      setInformation({ ...information, stars: holder });
    }
  };
  const handleeditstars = () => {
    let holder = Array.isArray(question.stars)
      ? [...question.stars]
      : new Array(question.stars || 3).fill('');
    if (holder.length === 10) {
      setStarmsg('Elija un valor entre 3 y 10');
    } else {
      setStarmsg('');
      holder.push('');
      setQuestion({ ...question, stars: holder });
    }
  };
  const handledeletestars = () => {
    if (information.stars.length === 3) {
      setStarmsg('Elija un valor entre 3 y 10');
    } else {
      setStarmsg('');
      let holder = [...information.stars];
      holder.splice(1, 1);
      setInformation({ ...information, stars: holder });
    }
  };
  const handleeditdeletestars = () => {
    let holder = [...question.stars];
    if (holder.length === 3) {
      setStarmsg('Elija un valor entre 3 y 10');
    } else {
      setStarmsg('');
      holder.splice(1, 1);
      setQuestion({ ...question, stars: holder });
    }
  };

  const handleaddoption = (type, newOptionValue = '', isOther = false) => {
    const holder = [...information.customOptions];

    // Prevención absoluta: eliminar cualquier "Otro" previo antes de crear uno nuevo
    if (isOther) {
      const filtered = holder.filter((opt) => !opt.isOther);
      holder.length = 0;
      holder.push(...filtered);
    }

    const defaultValue = '';

    // Solo añadir isOther si es true, omitir si es false
    const newOption = {
      value: newOptionValue || defaultValue,
      ...(isOther && { isOther: true }), // Solo añade isOther si es true
    };

    holder.push(newOption);

    const holder2 = [...(information.opcionesInputs || [])];
    holder2.push('');

    setInformation({
      ...information,
      customOptions: holder,
      opcionesInputs: type === 15 ? holder2 : information.opcionesInputs,
    });
  };

  const handleRemoveOption = (index) => {
    let holder = [...information.customOptions];
    holder.splice(index, 1);
    setInformation({ ...information, customOptions: holder });
  };

  const handleRemoveEditOption = (index) => {
    let holder = [...question.customOptions];
    holder.splice(index, 1);
    setQuestion({ ...question, customOptions: holder });
  };
  const handleeditaddoption = (type) => {
    if (type === 15) {
      let holder = [...question.customOptions];
      holder.push('');
      let holder2 = [...question.selectOptions];
      holder2.push('');
      setQuestion({
        ...question,
        customOptions: holder,
        selectOptions: holder2,
      });
    } else {
      let holder = [...question.customOptions];
      holder.push('');
      setQuestion({ ...question, customOptions: holder });
    }
  };
  const handleAdd = () => {
    setOpen(true);
  };

  /**
   * Handle edit question.
   *
   * @param index
   */
  const handleEdit = (index) => {
    setTarget(index);
    setQuestion(questions[index]);
    setCategoryId(null);
    setEdit(true);
  };

  const handleActualizar = async () => {
    if (question.typeId !== 21) {
      // categoryId es lo que el usuario seleccionó en este modal
      // question.categoryId es el valor que ya traía la pregunta
      const finalCategoryId = categoryId ?? question.categoryId;
      const categoryExists = categories.some(c => c.id === finalCategoryId);
      if (!categoryExists) {
        setCategoryError('Seleccione una categoría');
        return false;
      }
    }

    setCategoryError('');

    let holder = questions.map((val, index) => {
      if (index === target) {
        return {
          ...question,
          categoryId: categoryId ?? question.categoryId,
        };
      } else {
        return val;
      }
    });

    if (isTemplate && isUpdate) {
      updateTemplateQuestion();
    }

    setQuestions(holder);
    return true;
  };

  /**
   * Update template question.
   */
  const updateTemplateQuestion = async (newQuestion) => {
    const questionCopy = newQuestion || question;
    const questionId = Number(questionCopy.questionId) || 0;
    const questionBody = {
      id: questionId,
      templateId: Number(templateId),
      nameQuestion: questionCopy.name,
      numberQuestion: Number(target + 1),
      score: Number(questionCopy.stars) || null,
      typeQuestionId: questionCopy.typeId,
      description: questionCopy.description,
      categoryId: questionCopy.categoryId,
    };
    const { data: updatedQuestion } = await updateTemplateQuestionAPI(
      questionId,
      questionBody,
    );
    const questionOptions = [];

    if (questionCopy.customOptions || questionCopy.options) {
      const options = questionCopy.customOptions || questionCopy.options;

      options.forEach(async (option, index) => {
        const optionId = Number(questionCopy.questionOptions[index]?.id) || 0;

        const optionBody = {
          id: optionId,
          templateOptionsName: option,
          numberOption: index + 1,
          questionId: updatedQuestion.id,
        };
        const { data: updatedOption } = await updateTemplateOptionAPI(
          optionId,
          optionBody,
        );

        questionOptions.push(updatedOption);
      });
    }

    return {
      questionId: updatedQuestion.id,
      questionOptions: questionOptions,
    };
  };

  /**
   * Handle checked demographic.
   *
   * @param {string[]} demographics Can be ID or unique name.
   */
  const handleCheckedDemographic = (demographics) => {
    setData({ ...data, demographics });
  };

  /**
   * Handle new demographic change.
   *
   * @param {Object[]} demographics
   */
  const handleNewDemographicChange = (demographics) => {
    setNewDemographics(demographics);
  };

  const handleChangeDayConcurrency = (event) => {
    const inputValue = event.target.value;
    // Permitir solo números
    if (/^[1-9]\d*$/.test(inputValue) || inputValue === '') {
      setDayConcurrency(inputValue);
      setErrorDayConcurrency(false);
    } else {
      setErrorDayConcurrency(true);
    }
  };

  const handleIsView360 = (event) => {
    setIsView360(event.target.value === 'true');
  };

  function getStepMapping() {
    const baseSteps = ['Tipo Encuesta'];

    if (!isTemplate && !isView360) {
      baseSteps.push('Privacidad');
    }

    baseSteps.push('Configuración');

    if (!isView360 && !openMailBox) {
      baseSteps.push('Concurrencia');
    }

    if (!isCompletedAnonymous) {
      baseSteps.push('Auto Guardado');
    }

    if (isCompletedAnonymous) {
      baseSteps.push('Mapa encuesta');
    } else {
      baseSteps.push('Configuración correo');
    }

    baseSteps.push('Cuestionario');

    return baseSteps;
  }
  const renderSwitch = (activeStep) => {
    if (isEdit) {
      // Lógica para modo edición
      switch (activeStep) {
        case 0: // Configuración
          return (
            <Box width="100%">
              {!isView360 && (
                <Exclusiveness
                  exclusiviness={exclusiviness}
                  handleExclusiviness={handleExclusiviness}
                  isCompletedAnonymous={isCompletedAnonymous}
                />
              )}
              <SaveOption saveOption={saveOption} setSaveOption={setSaveOption} />
              <Box sx={{ mb: 3 }}>
                <Typography sx={{ mb: 1, fontWeight: 500 }}>
                  Fechas de la encuesta
                </Typography>
                <LocalizationProvider
                  dateAdapter={AdapterDayjs}
                  localeText={
                    esES.components.MuiLocalizationProvider.defaultProps.localeText
                  }
                >
                  <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 2 }}>
                    <DatePicker
                      label="Fecha de inicio"
                      value={startDate}
                      onChange={(fecha) => setStartDate(fecha)}
                      slotProps={{
                        textField: {
                          helperText: 'Déjala vacía si no hay inicio programado.',
                        },
                        field: { clearable: true },
                      }}
                    />
                    <DatePicker
                      label="Fecha de fin"
                      value={closingDate}
                      onChange={(fecha) => setClosingDate(fecha)}
                      slotProps={{
                        textField: {
                          error: fechasInvalidas,
                          helperText: fechasInvalidas
                            ? 'La fecha de fin no puede ser anterior a la de inicio.'
                            : 'Déjala vacía si no hay fin programado.',
                        },
                        field: { clearable: true },
                      }}
                    />
                  </Box>
                </LocalizationProvider>
                <Typography variant="caption" color="text.secondary">
                  Solo informativas: la encuesta no se abre ni se cierra sola.
                </Typography>
              </Box>
              {!isView360 && (
                <>
                  <PrivacyPolicySection
                    privacyPolicyEnabled={privacyPolicyEnabled}
                    setPrivacyPolicyEnabled={setPrivacyPolicyEnabled}
                    dataPrivacyPolicyUrl={dataPrivacyPolicyUrl}
                    setDataPrivacyPolicyUrl={setDataPrivacyPolicyUrl}
                    dataPrivacyPolicyText={dataPrivacyPolicyText}
                    setDataPrivacyPolicyText={setDataPrivacyPolicyText}
                    checkboxLabel={checkboxLabel}
                    setCheckboxLabel={setCheckboxLabel}
                    acceptButtonText={acceptButtonText}
                    setAcceptButtonText={setAcceptButtonText}
                    declineButtonText={declineButtonText}
                    setDeclineButtonText={setDeclineButtonText}
                    urlError={urlError}
                    handleUrlChange={handleUrlChange}
                    quillModules={quillModules}
                    styles={styles}
                    declineMessage={declineMessage}
                    updateDeclineMessage={updateDeclineMessage}
                  />
                  <ResponseLimitSection
                    responseLimitEnabled={responseLimitEnabled}
                    setResponseLimitEnabled={setResponseLimitEnabled}
                    maxResponses={maxResponses}
                    setMaxResponses={setMaxResponses}
                    //limitReachedMessage={limitReachedMessage}
                    //updateLimitReachedMessage={updateLimitReachedMessage}
                    styles={styles}
                  />
                  <IntroductionSurvey
                    isEnabledIntroduction={isEnabledIntroduction}
                    setIsEnabledIntroduction={setIsEnabledIntroduction}
                    introductionText={introductionText}
                    setIntroductionText={setIntroductionText}
                  />
                  <FontSelector
                    selectedFont={selectedFont}
                    setSelectedFont={setSelectedFont}
                  />
                  <MessagesSurvey
                    surveyMessages={surveyMessages}
                    setSurveyMessages={setSurveyMessages}
                    quillModules={quillModules}
                  />
                  <WhatsAppForSurvey
                    hasWhatsApp={hasWhatsApp}
                    handleHasWhatsApp={handleHasWhatsApp}
                  />
                  <div className={styles.input}>
                    <TextField
                      select
                      label="Tipo de validación"
                      value={textTypeGenericInput}
                      name="validationType"
                      onChange={(e) => setTextTypeGenericInput(e.target.value)}
                      fullWidth
                      size="small"
                      helperText="Selecciona el tipo de entrada permitida"
                    >
                      <MenuItem value="text">
                        Alfanumérico (texto libre)
                      </MenuItem>
                      <MenuItem value="number">Solo números</MenuItem>
                      <MenuItem value="email">Solo correo electrónico</MenuItem>
                    </TextField>
                  </div>
                  {/* Misma condición que al crear (línea 2488). Decía
                      (!isEdit || isCompletedAnonymous), que aquí dentro equivale a
                      lo contrario. */}
                  {!isCompletedAnonymous && (
                    <>
                      <OpenMailBox
                        openMailBox={openMailBox}
                        handleOpenMailBox={handleOpenMailBox}
                      />
                      {openMailBox && (
                        <MessagesOpenMailBoxSurvey
                          surveyOpenMailBoxMessages={surveyOpenMailBoxMessages}
                          setSurveyOpenMailBoxMessages={
                            setSurveyOpenMailBoxMessages
                          }
                        />
                      )}
                    </>
                  )}
                </>
              )}
              <EvaAgentsConfig
                haveAnalysis={haveEvaAgents}
                handleHaveAnalysis={handleHaveEvaAgents}
                reportConfigurationIds={reportConfigurationIds}
                setReportConfigurationIds={setReportConfigurationIds}
              />
              <HaveReportPDF
                haveReportPDF={haveReportPDF}
                handleHaveReportPDF={handleHaveReportPDF}
              />
              <NumerationSurvey
                hasNumerationNumber={hasNumerationNumber}
                setHasNumerationNumber={setHasNumerationNumber}
              />
              <PaginationSurvey
                questionsPerPage={questionsPerPage}
                setQuestionsPerPage={setQuestionsPerPage}
              />
              <BackgroundBannerImage
                bannerImage={bannerImage}
                setBannerImage={setBannerImage}
                backgroundImage={backgroundImage}
                setBackgroundImage={setBackgroundImage}
              />
              <ColorSurvey
                primaryColor={primaryColor}
                setPrimaryColor={setPrimaryColor}
                secondaryColor={secondaryColor}
                setSecondaryColor={setSecondaryColor}
                data={data}
              />
            </Box>
          );
        case 1: // Configuración correo / Mapa encuesta
          return (
            <Introduction
              onUpdated={handleIntroductionChange}
              checkForm={checkForm}
              previousData={data}
              isUpdate={isUpdate}
              mapsLoaded={mapsLoaded}
              setMapsLoaded={setMapsLoaded}
              includeLogo={includeLogo}
              setIncludeLogo={setIncludeLogo}
              ref={introRef}
              isEdit={isEdit}
              showOnlyMap={isCompletedAnonymous}
              quillModules={quillModules}
            />
          );
        case 2:
          return (
            <Box width="100%">
              <DemographicDataForm
                onChange={handleCheckedDemographic}
                onChangeNewDemographics={handleNewDemographicChange}
                templateDemographicData={templateDemographics}
                demographics={demographics}
                setDemographics={setDemographics}
              />
              <Divider />
              <Cuestionario
                questions={questions}
                setQuestions={setQuestions}
                hasWhatsApp={hasWhatsApp}
                onEnd={onEnd}
                handleAdd={handleAdd}
                handleDelete={handleDelete}
                handleEdit={handleEdit}
                setConditionalQuestion={setConditionalQuestion}
                setType={setType}
                handleAddQuestion={handleAddQuestion}
                handleCategoryIdChange={handleCategoryIdChange}
                getOptions={getOptions}
                setCategoryId={setCategoryId}
                saveOption={saveOption}
                scrollToQuestionId={scrollToQuestionId} // ✅ Nueva prop
                onScrollComplete={() => setScrollToQuestionId(null)} // ✅ Nueva prop
                questionIdDelete={questionIdDelete}
                setQuestionIdDelete={setQuestionIdDelete}
              />
            </Box>
          );
        default:
          return null;
      }
    }

    // Lógica para modo creación - mapear según las condiciones
    const stepLabels = getStepMapping();
    const currentStepLabel = stepLabels[activeStep];

    switch (currentStepLabel) {
      case 'Tipo Encuesta':
        return (
          <>
            <View360
              isView360={isView360}
              handleIsView360={handleIsView360}
              excelFile360={excelFile360}
              setExcelFile360={setExcelFile360}
              setView360={setView360}
            />
          </>
        );

      case 'Privacidad':
        return (
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              width: '100%',
              gap: '25px',
            }}
          >
            <div style={{ display: 'flex', width: '100%' }}>
              <Intimidad
                anonyme={anonymous}
                handleAnonyme={handleanonyme}
                isCompletedAnonymous={isCompletedAnonymous}
              />
              {!isView360 && (
                <Exclusiveness
                  exclusiviness={exclusiviness}
                  handleExclusiviness={handleExclusiviness}
                  isCompletedAnonymous={isCompletedAnonymous}
                />
              )}
            </div>
          </div>
        );

      case 'Configuración':
        return (
          <Box width="100%">
            {!isView360 && (
              <>
                <PrivacyPolicySection
                  privacyPolicyEnabled={privacyPolicyEnabled}
                  setPrivacyPolicyEnabled={setPrivacyPolicyEnabled}
                  dataPrivacyPolicyUrl={dataPrivacyPolicyUrl}
                  setDataPrivacyPolicyUrl={setDataPrivacyPolicyUrl}
                  dataPrivacyPolicyText={dataPrivacyPolicyText}
                  setDataPrivacyPolicyText={setDataPrivacyPolicyText}
                  checkboxLabel={checkboxLabel}
                  setCheckboxLabel={setCheckboxLabel}
                  acceptButtonText={acceptButtonText}
                  setAcceptButtonText={setAcceptButtonText}
                  declineButtonText={declineButtonText}
                  setDeclineButtonText={setDeclineButtonText}
                  urlError={urlError}
                  handleUrlChange={handleUrlChange}
                  quillModules={quillModules}
                  styles={styles}
                  declineMessage={declineMessage}
                  updateDeclineMessage={updateDeclineMessage}
                />
                <Box sx={{ mb: 3 }}>
                  <Typography sx={{ mb: 1, fontWeight: 500 }}>
                    Fechas de la encuesta
                  </Typography>
                  <LocalizationProvider
                    dateAdapter={AdapterDayjs}
                    localeText={
                      esES.components.MuiLocalizationProvider.defaultProps.localeText
                    }
                  >
                    <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 2 }}>
                      <DatePicker
                        label="Fecha de inicio"
                        value={startDate}
                        onChange={(fecha) => setStartDate(fecha)}
                        slotProps={{
                          textField: {
                            helperText: 'Déjala vacía si no hay inicio programado.',
                          },
                          field: { clearable: true },
                        }}
                      />
                      <DatePicker
                        label="Fecha de fin"
                        value={closingDate}
                        onChange={(fecha) => setClosingDate(fecha)}
                        slotProps={{
                          textField: {
                            error: fechasInvalidas,
                            helperText: fechasInvalidas
                              ? 'La fecha de fin no puede ser anterior a la de inicio.'
                              : 'Déjala vacía si no hay fin programado.',
                          },
                          field: { clearable: true },
                        }}
                      />
                    </Box>
                  </LocalizationProvider>
                  <Typography variant="caption" color="text.secondary">
                    Solo informativas: la encuesta no se abre ni se cierra sola.
                  </Typography>
                </Box>
                <ResponseLimitSection
                  responseLimitEnabled={responseLimitEnabled}
                  setResponseLimitEnabled={setResponseLimitEnabled}
                  maxResponses={maxResponses}
                  setMaxResponses={setMaxResponses}
                  //limitReachedMessage={limitReachedMessage}
                  //updateLimitReachedMessage={updateLimitReachedMessage}
                  styles={styles}
                />
                <IntroductionSurvey
                  isEnabledIntroduction={isEnabledIntroduction}
                  setIsEnabledIntroduction={setIsEnabledIntroduction}
                  introductionText={introductionText}
                  setIntroductionText={setIntroductionText}
                />

                <FontSelector
                  selectedFont={selectedFont}
                  setSelectedFont={setSelectedFont}
                />
                <MessagesSurvey
                  surveyMessages={surveyMessages}
                  setSurveyMessages={setSurveyMessages}
                  quillModules={quillModules}
                />
                <WhatsAppForSurvey
                  hasWhatsApp={hasWhatsApp}
                  handleHasWhatsApp={handleHasWhatsApp}
                />
                <div className={styles.input}>
                  <TextField
                    select
                    label="Tipo de validación"
                    value={textTypeGenericInput}
                    name="validationType"
                    onChange={(e) => setTextTypeGenericInput(e.target.value)}
                    fullWidth
                    size="small"
                    helperText="Selecciona el tipo de entrada permitida"
                  >
                    <MenuItem value="text">Alfanumérico (texto libre)</MenuItem>
                    <MenuItem value="number">Solo números</MenuItem>
                    <MenuItem value="email">Solo correo electrónico</MenuItem>
                  </TextField>
                </div>
                {!isCompletedAnonymous && (
                  <>
                    <OpenMailBox
                      openMailBox={openMailBox}
                      handleOpenMailBox={handleOpenMailBox}
                    />
                    {openMailBox && (
                      <MessagesOpenMailBoxSurvey
                        surveyOpenMailBoxMessages={surveyOpenMailBoxMessages}
                        setSurveyOpenMailBoxMessages={
                          setSurveyOpenMailBoxMessages
                        }
                      />
                    )}
                  </>
                )}
              </>
            )}
            <EvaAgentsConfig
              haveAnalysis={haveEvaAgents}
              handleHaveAnalysis={handleHaveEvaAgents}
              reportConfigurationIds={reportConfigurationIds}
              setReportConfigurationIds={setReportConfigurationIds}
            />
            <HaveReportPDF
              haveReportPDF={haveReportPDF}
              handleHaveReportPDF={handleHaveReportPDF}
            />
            <NumerationSurvey
              hasNumerationNumber={hasNumerationNumber}
              setHasNumerationNumber={setHasNumerationNumber}
            />
            <PaginationSurvey
              questionsPerPage={questionsPerPage}
              setQuestionsPerPage={setQuestionsPerPage}
            />
            <BackgroundBannerImage
              bannerImage={bannerImage}
              setBannerImage={setBannerImage}
              backgroundImage={backgroundImage}
              setBackgroundImage={setBackgroundImage}
            />
            <ColorSurvey
              primaryColor={primaryColor}
              setPrimaryColor={setPrimaryColor}
              secondaryColor={secondaryColor}
              setSecondaryColor={setSecondaryColor}
              data={data}
            />
          </Box>
        );

      case 'Concurrencia':
        return (
          <div
            style={{ display: 'flex', flexDirection: 'column', width: '100%' }}
          >
            <MultiAnswerSurvey
              isAMultiAnswerSurvey={isAMultiAnswerSurvey}
              handleMultiAnswerSurvey={handleMultiAnswerSurvey}
            />
            {isAMultiAnswerSurvey && (
              <>
                <p>
                  Ingrese cada cuántos días se va repetir la encuesta para los
                  usuarios:
                </p>
                <TextField
                  label="Días"
                  value={dayConcurrency}
                  onChange={handleChangeDayConcurrency}
                  type="text"
                  inputProps={{ inputMode: 'numeric', pattern: '^[1-9]\\d*$' }}
                  error={!!errorDayConcurrency}
                  helperText={
                    errorDayConcurrency
                      ? 'El valor no puede ser 0 ni estar vacío'
                      : ' '
                  }
                />
              </>
            )}
          </div>
        );

      case 'Auto Guardado':
        return (
          <SaveOption saveOption={saveOption} setSaveOption={setSaveOption} />
        );

      case 'Configuración correo':
        return (
          <Introduction
            onUpdated={handleIntroductionChange}
            checkForm={checkForm}
            previousData={data}
            isUpdate={isUpdate}
            mapsLoaded={mapsLoaded}
            setMapsLoaded={setMapsLoaded}
            includeLogo={includeLogo}
            setIncludeLogo={setIncludeLogo}
            ref={introRef}
            isEdit={isEdit}
            quillModules={quillModules}
          />
        );

      case 'Mapa encuesta':
        return (
          <Introduction
            onUpdated={handleIntroductionChange}
            checkForm={checkForm}
            previousData={data}
            isUpdate={isUpdate}
            mapsLoaded={mapsLoaded}
            setMapsLoaded={setMapsLoaded}
            includeLogo={includeLogo}
            setIncludeLogo={setIncludeLogo}
            ref={introRef}
            isEdit={isEdit}
            showOnlyMap
            quillModules={quillModules}
          />
        );

      case 'Cuestionario':
        return (
          <Box width="100%">
            <DemographicDataForm
              onChange={handleCheckedDemographic}
              onChangeNewDemographics={handleNewDemographicChange}
              templateDemographicData={templateDemographics}
              demographics={demographics}
              setDemographics={setDemographics}
            />
            <Divider />
            <Cuestionario
              questions={questions}
              setQuestions={setQuestions}
              hasWhatsApp={hasWhatsApp}
              onEnd={onEnd}
              handleAdd={handleAdd}
              handleDelete={handleDelete}
              handleEdit={handleEdit}
              setConditionalQuestion={setConditionalQuestion}
              setType={setType}
              handleAddQuestion={handleAddQuestion}
              handleCategoryIdChange={handleCategoryIdChange}
              getOptions={getOptions}
              setCategoryId={setCategoryId}
              saveOption={saveOption}
              scrollToQuestionId={scrollToQuestionId} // ✅ Nueva prop
              onScrollComplete={() => setScrollToQuestionId(null)} // ✅ Nueva prop
              questionIdDelete={questionIdDelete}
              setQuestionIdDelete={setQuestionIdDelete}
            />
          </Box>
        );

      default:
        return null;
    }
  };
  const handleCloseModal = () => {
    setOpen(false);
    setEdit(false);
  };
  const handleCloseEditModal = () => setEdit(false);

  const handleanonyme = (event) => {
    const value = event.target.value;

    if (value === 'anonima') {
      setIsCompletedAnonymous(true);
      setAnonymous(false); // no aplica en este caso
    } else if (value === 'semiAnonima') {
      setIsCompletedAnonymous(false);
      setAnonymous(true);
    } else if (value === 'identificada') {
      setIsCompletedAnonymous(false);
      setAnonymous(false);
    }
  };
  const handleExclusiviness = (event) => {
    setExclusiviness(event.target.value === 'true');
  };
  const handleOpenMailBox = (checked) => {
    setOpenMailBox(checked);
  };

  const handleHaveEvaAgents = (checked) => {
    setHaveEvaAgents(checked);
  };

  const handleHaveReportPDF = (checked) => {
    setHaveReportPDF(checked);
  };
  const handleHasWhatsApp = (checked) => {
    if (checked) {
      const incompatibleQuestions = showWhatsAppIncompatibleWarning();

      if (incompatibleQuestions.length > 0) {
        setScrollToQuestionId(incompatibleQuestions[0].id);
        setHasWhatsApp(false);
        return;
      }
    }

    setHasWhatsApp(checked);
  };

  const handleMultiAnswerSurvey = (event) => {
    setIsAMultiAnswerSurvey(event.target.value === 'true');
  };

  const reorder = (list, start, end) => {
    const result = Array.from(list);
    const [removed] = result.splice(start, 1);
    result.splice(end, 0, removed);
    return result;
  };

  /**
   * Las opciones de una pregunta condicional guardan el NÚMERO de la pregunta hija.
   * Al renumerar (mover o borrar) hay que trasladar ese número al nuevo número de la
   * misma pregunta; si no, la condición queda apuntando a otra pregunta.
   * Si la hija se borró, la opción queda sin destino para que el editor obligue a elegir otra.
   *
   * @param {Array} previousQuestions Preguntas con la numeración anterior.
   * @param {Array} renumberedQuestions Preguntas ya renumeradas.
   * @returns {{ questions: Array, newNumberById: Map }}
   */
  const remapConditionalChildren = (previousQuestions, renumberedQuestions) => {
    const newNumberById = new Map(
      renumberedQuestions.map((q) => [q.id, q.questionNumber]),
    );
    const newNumberByOld = new Map(
      previousQuestions.map((q) => [
        String(q.questionNumber),
        newNumberById.has(q.id) ? String(newNumberById.get(q.id)) : '',
      ]),
    );

    // '0' es "Fin de la encuesta" y '' es sin destino: no se tocan.
    const remap = (child) => {
      if (child === null || child === undefined) return child;
      const key = String(child);
      if (key === '' || key === '0') return child;
      return newNumberByOld.has(key) ? newNumberByOld.get(key) : child;
    };

    const remappedQuestions = renumberedQuestions.map((q) => {
      if (!q.conditionalQuestion) return q;
      return {
        ...q,
        childQuestionIds: q.childQuestionIds?.map(remap),
        questionOptions: q.questionOptions?.map((option) => ({
          ...option,
          questionChildren: remap(option.questionChildren),
        })),
      };
    });

    return { questions: remappedQuestions, newNumberById };
  };

  /**
   * Sincroniza las selecciones del autocomplete de hijas con la nueva numeración.
   */
  const remapChildSelections = (newNumberById) => {
    setSelections((prev) => {
      const updated = {};
      Object.entries(prev).forEach(([key, selected]) => {
        if (!selected || !newNumberById.has(selected.id)) {
          // "Fin de la encuesta" (id fijo) se conserva; una hija borrada se descarta.
          if (selected && selected.questionNumber === 0) updated[key] = selected;
          return;
        }
        const questionNumber = newNumberById.get(selected.id);
        updated[key] = {
          ...selected,
          questionNumber,
          displayNumber: questionNumber,
        };
      });
      return updated;
    });
  };

  const onEnd = (result) => {
    if (!result.destination) {
      return;
    }
    const reorderedItems = reorder(
      questions,
      result.source.index,
      result.destination.index,
    );

    const updatedQuestions = reorderedItems.map((item, index) => ({
      ...item,
      questionNumber: index + 1, // Actualizar el número de la pregunta
    }));

    const { questions: remappedQuestions, newNumberById } =
      remapConditionalChildren(questions, updatedQuestions);
    remapChildSelections(newNumberById);
    setQuestions(remappedQuestions);
  };

  const handleAutocomplete = (val) => {
    if (
      val &&
      hasWhatsApp &&
      !WHATSAPP_QUESTION_TYPE_IDS.includes(val.id)
    ) {
      enqueueSnackbar(
        'WhatsApp solo permite preguntas de texto, selección, Likert y texto informativo.',
        {
          variant: 'warning',
          autoHideDuration: 3000,
        },
      );
      setType(null);
      return;
    }

    setType(val);

    if (!val) {
      // Si el valor es null, probablemente quieras limpiar también las opciones
      setInformation((prevInfo) => ({
        ...prevInfo,
        options: [],
      }));
      return;
    }

    const updatedOptions = getOptions(val.id);

    setInformation((prevInfo) => ({
      ...prevInfo,
      options: updatedOptions,
      customOptions: Array(2).fill(''),
    }));
  };

  function getOptions(lang) {
    if (lang === 16) {
      // Verifica el valor del idioma
      return [
        'Strongly Agree',
        'Agree',
        'Neither Agree nor Disagree',
        'Disagree',
        'Strongly Disagree',
      ];
    } else {
      return [
        'Totalmente de Acuerdo',
        'De Acuerdo',
        'Ni de Acuerdo Ni en Desacuerdo',
        'En Desacuerdo',
        'Totalmente en Desacuerdo',
      ];
    }
  }

  const validateYouTubeUrl = (url) => {
    const youtubeRegex =
      /^(https?:\/\/)?(www\.)?(youtube\.com\/watch\?v=|youtu\.be\/)[a-zA-Z0-9_-]{11}$/;
    return youtubeRegex.test(url);
  };

  const handleAgregar = async () => {
    setCategoryError('');
    setErrorMessage({});
    setHelperText({});

    if (edit) {
      if (question.name.length < 5) {
        setErrorMessage({
          ...errorMessage,
          name: true,
        });
        setHelperText({
          ...helperText,
          name: 'Se requiere un mínimo de 5 caracteres.',
        });

        return;
      } else if (question.name.length > 1000) {
        setErrorMessage({
          ...errorMessage,
          name: true,
        });
        setHelperText({
          ...helperText,
          name: 'El número máximo de carácteres de 1000.',
        });
        return;
      }

      if (question.description.length > 1000) {
        setErrorMessage({
          ...errorMessage,
          name: true,
        });
        setHelperText({
          ...helperText,
          name: 'El número máximo de carácteres de 1000.',
        });
      }

      if (question.typeId === 1 && question.haveLimit) {
        const value = Number(question.wordSizeLimit);

        if (
          !question.wordSizeLimit ||
          question.wordSizeLimit.toString().trim() === ''
        ) {
          setErrorMessage((prev) => ({
            ...prev,
            wordSizeLimit: true,
          }));
          setHelperText((prev) => ({
            ...prev,
            wordSizeLimit: 'El límite de caracteres no puede estar vacío.',
          }));
          return;
        }

        if (isNaN(value)) {
          setErrorMessage((prev) => ({
            ...prev,
            wordSizeLimit: true,
          }));
          setHelperText((prev) => ({
            ...prev,
            wordSizeLimit: 'Debe ingresar un número válido.',
          }));
          return;
        }

        if (!Number.isInteger(value)) {
          setErrorMessage((prev) => ({
            ...prev,
            wordSizeLimit: true,
          }));
          setHelperText((prev) => ({
            ...prev,
            wordSizeLimit: 'Solo se permiten números enteros.',
          }));
          return;
        }

        if (value < 8) {
          setErrorMessage((prev) => ({
            ...prev,
            wordSizeLimit: true,
          }));
          setHelperText((prev) => ({
            ...prev,
            wordSizeLimit: 'El límite mínimo es de 8 caracteres.',
          }));
          return;
        }

        if (value > 5000) {
          setErrorMessage((prev) => ({
            ...prev,
            wordSizeLimit: true,
          }));
          setHelperText((prev) => ({
            ...prev,
            wordSizeLimit: 'El límite máximo es de 5000 caracteres.',
          }));
          return;
        }
      }

      if (
        question.customOptions !== null &&
        (question.typeId === 3 ||
          question.typeId === 8 ||
          question.typeId === 24) &&
        question.customOptions.some((option) => option === '')
      ) {
        setCustomOptionError(
          question.customOptions.map((option) => option === ''),
        );
        return;
      }

      if (question.typeId === 8 && question.conditionalQuestion) {
        // Asumiendo que tipo 8 es el que usa Autocomplete
        const autoCompleteErrors = question.customOptions.map(
          (option, index) => {
            const selection = selections[`${question.id}-${index}`];
            return !selection; // Retorna true si la selección es nula o indefinida
          },
        );

        // Verifica si algún Autocomplete está vacío
        if (autoCompleteErrors.some((error) => error)) {
          setErrorMessage({
            ...errorMessage,
            autocomplete: true,
          });
          setHelperText({
            ...helperText,
            autocomplete: 'Debe seleccionar una pregunta para cada opción.',
          });
          return; // Detiene la ejecución si hay errores
        }
      }

      if (question.typeId === 19) {
        const value = Number(question.stars);
        if (isNaN(value)) {
          setErrorMessage((prev) => ({
            ...prev,
            bipolar: true,
          }));
          setHelperText((prev) => ({
            ...prev,
            bipolar: 'Debe ingresar un número.',
          }));
          return;
        }

        if (!Number.isInteger(value)) {
          setErrorMessage((prev) => ({
            ...prev,
            bipolar: true,
          }));
          setHelperText((prev) => ({
            ...prev,
            bipolar: 'Solo se permiten números enteros.',
          }));
          return;
        }

        // Validación: valor vacío o menor o igual a 0
        if (information.stars === '' || value <= 0) {
          setErrorMessage((prev) => ({
            ...prev,
            bipolar: true,
          }));
          setHelperText((prev) => ({
            ...prev,
            bipolar: 'El valor debe ser mayor a 0.',
          }));
          return;
        }

        // Validación: valor mayor a 10
        if (value > 10) {
          setErrorMessage((prev) => ({
            ...prev,
            bipolar: true,
          }));
          setHelperText((prev) => ({
            ...prev,
            bipolar: 'El valor no puede ser mayor a 10.',
          }));
          return;
        }
      }
      if (question.typeId === 22) {
        // Validación: extremos vacíos
        if (
          question.textsBipolarBar.leftText.trim() === '' ||
          question.textsBipolarBar.rightText.trim() === ''
        ) {
          setErrorMessage((prev) => ({
            ...prev,
            bipolarText: true,
          }));
          setHelperText((prev) => ({
            ...prev,
            bipolarText:
              'Debe completar los textos de los extremos de la escala bipolar.',
          }));
          return;
        }
      }

      if (limitType === 'fijo' && question.typeId === 3) {
        if (question.stars.toString().trim() === '') {
          setErrorMessage({
            ...errorMessage,
            maximunValueOptions: true,
          });
          setHelperText({
            ...helperText,
            maximunValueOptions: 'Este valor no puede ir vacío',
          });
          return;
        }

        if (isNaN(question.stars)) {
          setErrorMessage((prev) => ({
            ...prev,
            maximunValueOptions: true,
          }));
          setHelperText((prev) => ({
            ...prev,
            maximunValueOptions: 'Debe ingresar un número.',
          }));
          return;
        }

        if (!Number.isInteger(Number(question.stars))) {
          setErrorMessage((prev) => ({
            ...prev,
            maximunValueOptions: true,
          }));
          setHelperText((prev) => ({
            ...prev,
            maximunValueOptions: 'Solo se permiten números enteros.',
          }));
          return;
        }

        if (Number(question.stars) <= 0) {
          setErrorMessage((prev) => ({
            ...prev,
            maximunValueOptions: true,
          }));
          setHelperText((prev) => ({
            ...prev,
            maximunValueOptions: 'Debe ser un número mayor a 0.',
          }));
          return;
        }

        if (Number(question.stars) >= question.customOptions.length) {
          setErrorMessage({
            ...errorMessage,
            maximunValueOptions: true,
          });
          setHelperText({
            ...helperText,
            maximunValueOptions:
              'No puede colocar un valor mayor ni igual al número de opciones que tiene la pregunta.',
          });
          return;
        }
      }

      if (question.typeId === 25) {
        const rows = question.matrixOption?.options || [];
        const columns = question.matrixOption?.values || [];

        const shouldValidateRows =
          question.matrixOption?.matrixType !== 'dynamic';

        const isDynamic = question.matrixOption?.matrixType === 'dynamic';
        const dynamicOptions = question.matrixOption?.options || [];
        const nonEmptyOptions = dynamicOptions.filter(
          (opt) => opt && opt.toString().trim() !== '',
        );
        const isExcelEmpty = isDynamic && nonEmptyOptions.length === 0;
        const hasEmptyRow = shouldValidateRows
          ? rows.some((row) => !row || row.trim() === '')
          : false;
        const hasEmptyColumn = columns.some((col) => !col || col.trim() === '');
        if (hasEmptyRow || hasEmptyColumn || isExcelEmpty) {
          setErrorMessage((prev) => ({
            ...prev,
            matrixRows: shouldValidateRows
              ? rows.map((row) => !row || row.trim() === '')
              : [], // no marcar errores si no se validan
            matrixCols: columns.map((col) => !col || col.trim() === ''),
          }));
          setHelperText((prev) => ({
            ...prev,
            matrix: isExcelEmpty
              ? 'Debes cargar un archivo Excel con al menos una opción.'
              : 'Este campo no puede ir vacío',
          }));
          return;
        }
      }
      if (question.typeId === 27 || question.typeId === 26) {
        // Falta el Excel solo si además no hay ninguna opción con contenido. Al editar una
        // pregunta que ya existe nunca hay `file` -el archivo se subió al crearla- y las
        // opciones se reconstruyen en customOptions, así que exigir el archivo dejaba el
        // botón Actualizar sin efecto y sin mensaje: no se podía editar nunca.
        //
        // Se cuentan las opciones NO vacías, no el largo: una pregunta nueva arranca con
        // dos opciones en blanco, y mirar solo el largo dejaría crear una sin Excel.
        const opcionesConContenido = (question.customOptions || []).filter((opcion) => {
          const valor = typeof opcion === 'string' ? opcion : opcion?.value;
          return valor && valor.trim() !== '';
        }).length;

        if (!question.file && opcionesConContenido === 0) {
          setErrorMessage((prev) => ({
            ...prev,
            selectedFileSelectQuestionError: true,
          }));
          setHelperText((prev) => ({
            ...prev,
            selectedFileSelectQuestionHelpertext:
              'El archivo excel no puede estar vacío',
          }));
          return;
        }
        if (question.haveLimit) {
          const value = Number(question.limitOptions);

          if (
            !question.limitOptions ||
            question.limitOptions.toString().trim() === ''
          ) {
            setErrorMessage((prev) => ({
              ...prev,
              limitOptions: true,
            }));
            setHelperText((prev) => ({
              ...prev,
              limitOptions: 'El límite de opciones no puede estar vacío.',
            }));
            return;
          }

          if (isNaN(value)) {
            setErrorMessage((prev) => ({
              ...prev,
              limitOptions: true,
            }));
            setHelperText((prev) => ({
              ...prev,
              limitOptions: 'Debe ingresar un número válido.',
            }));
            return;
          }

          if (!Number.isInteger(value)) {
            setErrorMessage((prev) => ({
              ...prev,
              limitOptions: true,
            }));
            setHelperText((prev) => ({
              ...prev,
              limitOptions: 'Solo se permiten números enteros.',
            }));
            return;
          }

          if (value < 1) {
            setErrorMessage((prev) => ({
              ...prev,
              limitOptions: true,
            }));
            setHelperText((prev) => ({
              ...prev,
              limitOptions: 'El límite mínimo es de 1 opción.',
            }));
            return;
          }

          if (value > 10) {
            setErrorMessage((prev) => ({
              ...prev,
              limitOptions: true,
            }));
            setHelperText((prev) => ({
              ...prev,
              limitOptions: 'El límite máximo es de 10 opciones.',
            }));
            return;
          }
        }
      }

      if (question.typeId === 28) {
        if (!question.multimedia.type || !question.multimedia.urlMedia) {
          setErrorMessage((prev) => ({
            ...prev,
            multimedia: {
              ...(prev.multimedia ?? {}),
              general: true,
            },
          }));
          setHelperText((prev) => ({
            ...prev,
            multimedia: {
              ...(prev.multimedia ?? {}),
              general: 'Debe agregar una imagen, video o URL de YouTube.',
            },
          }));
          return;
        }

        if (
          question.multimedia.type === 'youtube' &&
          (typeof question.multimedia.urlMedia !== 'string' ||
            !validateYouTubeUrl(question.multimedia.urlMedia))
        ) {
          setErrorMessage((prev) => ({
            ...prev,
            multimedia: {
              ...(prev.multimedia ?? {}),
              youtube: true,
            },
          }));

          setHelperText((prev) => ({
            ...prev,
            multimedia: {
              ...(prev.multimedia ?? {}),
              youtubeMessage:
                'La URL ingresada no es válida. Asegúrese de que sea un enlace de YouTube.',
            },
          }));
          return;
        }

        // Limpiar errores si todo está bien
        setErrorMessage((prev) => ({
          ...prev,
          multimedia: {
            general: false,
            youtube: false,
          },
        }));

        setHelperText((prev) => ({
          ...prev,
          multimedia: {
            general: '',
            youtubeMessage: '',
          },
        }));
      }

      // Después de las validaciones de question.typeId === 28 y antes de handleActualizar()
      if (question.typeId === 29) {
        const tableOptions = question.tableSetting?.options || [];

        // Validar que haya al menos una columna
        if (tableOptions.length === 0) {
          enqueueSnackbar('Debe agregar al menos una columna a la tabla', {
            variant: 'error',
            autoHideDuration: 3000,
          });
          return;
        }

        // Validar que ninguna columna tenga el nombre vacío
        const hasEmptyColumn = tableOptions.some(
          (column) => !column.value || column.value.trim() === '',
        );

        if (hasEmptyColumn) {
          setErrorMessage((prev) => ({
            ...prev,
            columns: tableOptions.map(
              (col) => !col.value || col.value.trim() === '',
            ),
          }));
          setHelperText((prev) => ({
            ...prev,
            tableColumns: 'Todas las columnas deben tener un nombre',
          }));
          return;
        }
      }

      setErrorMessage({});
      setHelperText({});
      setCustomOptionError([]);

      const success = await handleActualizar(); // ← capturar resultado
      if (success) {
        handleCloseModal(); // ← solo cerrar si fue exitoso
      }

      return;
    }

    if (hasWhatsApp && !WHATSAPP_QUESTION_TYPE_IDS.includes(type?.id)) {
      enqueueSnackbar(
        'WhatsApp solo permite crear preguntas de texto, selección, Likert y texto informativo.',
        {
          variant: 'warning',
          autoHideDuration: 3000,
        },
      );
      return;
    }

    if (information.name.length < 5) {
      setErrorMessage({
        ...errorMessage,
        name: true,
      });
      setHelperText({
        ...helperText,
        name: 'Se requiere un mínimo de 5 carácteres.',
      });

      return;
    } else if (information.name.length > 1000) {
      setErrorMessage({
        ...errorMessage,
        name: true,
      });
      setHelperText({
        ...helperText,
        name: 'El número máximo de carácteres de 1000.',
      });
      return;
    }

    if (information.description.length > 1000) {
      setErrorMessage({
        ...errorMessage,
        name: true,
      });
      setHelperText({
        ...helperText,
        name: 'El número máximo de carácteres de 1000.',
      });
    }

    if (type.id === 1 && information.haveLimit) {
      const value = Number(information.wordSizeLimit);

      if (
        !information.wordSizeLimit ||
        information.wordSizeLimit.toString().trim() === ''
      ) {
        setErrorMessage((prev) => ({
          ...prev,
          wordSizeLimit: true,
        }));
        setHelperText((prev) => ({
          ...prev,
          wordSizeLimit: 'El límite de caracteres no puede estar vacío.',
        }));
        return;
      }

      if (isNaN(value)) {
        setErrorMessage((prev) => ({
          ...prev,
          wordSizeLimit: true,
        }));
        setHelperText((prev) => ({
          ...prev,
          wordSizeLimit: 'Debe ingresar un número válido.',
        }));
        return;
      }

      if (!Number.isInteger(value)) {
        setErrorMessage((prev) => ({
          ...prev,
          wordSizeLimit: true,
        }));
        setHelperText((prev) => ({
          ...prev,
          wordSizeLimit: 'Solo se permiten números enteros.',
        }));
        return;
      }

      if (value < 8) {
        setErrorMessage((prev) => ({
          ...prev,
          wordSizeLimit: true,
        }));
        setHelperText((prev) => ({
          ...prev,
          wordSizeLimit: 'El límite mínimo es de 8 caracteres.',
        }));
        return;
      }

      if (value > 5000) {
        setErrorMessage((prev) => ({
          ...prev,
          wordSizeLimit: true,
        }));
        setHelperText((prev) => ({
          ...prev,
          wordSizeLimit: 'El límite máximo es de 5000 caracteres.',
        }));
        return;
      }
    }
    if (limitType === 'fijo' && type.id === 3) {
      if (information.maximunValueOptions.trim() === '') {
        setErrorMessage({
          ...errorMessage,
          maximunValueOptions: true,
        });
        setHelperText({
          ...helperText,
          maximunValueOptions: 'Este valor no puede ir vacío',
        });
        return;
      }

      if (isNaN(information.maximunValueOptions)) {
        setErrorMessage((prev) => ({
          ...prev,
          maximunValueOptions: true,
        }));
        setHelperText((prev) => ({
          ...prev,
          maximunValueOptions: 'Debe ingresar un número.',
        }));
        return;
      }

      if (!Number.isInteger(Number(information.maximunValueOptions))) {
        setErrorMessage((prev) => ({
          ...prev,
          maximunValueOptions: true,
        }));
        setHelperText((prev) => ({
          ...prev,
          maximunValueOptions: 'Solo se permiten números enteros.',
        }));
        return;
      }

      if (Number(information.maximunValueOptions) <= 0) {
        setErrorMessage((prev) => ({
          ...prev,
          maximunValueOptions: true,
        }));
        setHelperText((prev) => ({
          ...prev,
          maximunValueOptions: 'Debe ser un número mayor a 0.',
        }));
        return;
      }

      if (
        Number(information.maximunValueOptions) >=
        information.customOptions.length
      ) {
        setErrorMessage({
          ...errorMessage,
          maximunValueOptions: true,
        });
        setHelperText({
          ...helperText,
          maximunValueOptions:
            'No puede colocar un valor mayor ni igual al número de opciones que tiene la pregunta.',
        });
        return;
      }
    }

    if (
      !information.customOptions.every((elemento) => elemento !== '') &&
      (type.id === 3 || type.id === 8 || type.id === 15 || type.id === 24)
    ) {
      let checkCustomOptions = information.customOptions.map(
        (elemento) => elemento === '',
      );
      setCustomOptionError(checkCustomOptions);
      return;
    }

    if (
      !information.opcionesInputs.every((elemento) => elemento !== '') &&
      type.id === 15
    ) {
      let relationalOptions = information.opcionesInputs.map(
        (elemento) => elemento === '',
      );
      setOptionRelationalError(relationalOptions);
      return;
    }
    // ✅ Validación escala bipolar
    if (type.id === 19 || type.id === 24) {
      const value = Number(information.barBipolarValue);
      if (isNaN(value)) {
        setErrorMessage((prev) => ({
          ...prev,
          bipolar: true,
        }));
        setHelperText((prev) => ({
          ...prev,
          bipolar: 'Debe ingresar un número.',
        }));
        return;
      }

      if (!Number.isInteger(value)) {
        setErrorMessage((prev) => ({
          ...prev,
          bipolar: true,
        }));
        setHelperText((prev) => ({
          ...prev,
          bipolar: 'Solo se permiten números enteros.',
        }));
        return;
      }

      // Validación: valor vacío o menor o igual a 0
      if (information.barBipolarValue === '' || value <= 0) {
        setErrorMessage((prev) => ({
          ...prev,
          bipolar: true,
        }));
        setHelperText((prev) => ({
          ...prev,
          bipolar: 'El valor debe ser mayor a 0.',
        }));
        return;
      }

      // Validación: valor mayor a 10
      if (value > 10 && type.id !== 24) {
        setErrorMessage((prev) => ({
          ...prev,
          bipolar: true,
        }));
        setHelperText((prev) => ({
          ...prev,
          bipolar: 'El valor no puede ser mayor a 10.',
        }));
        return;
      }

      // Validación: extremos vacíos
      if (
        (information.textsBipolarBar.leftText.trim() === '' ||
          information.textsBipolarBar.rightText.trim() === '') &&
        type.id !== 24
      ) {
        setErrorMessage((prev) => ({
          ...prev,
          bipolarText: true,
        }));
        setHelperText((prev) => ({
          ...prev,
          bipolarText:
            'Debe completar los textos de los extremos de la escala bipolar.',
        }));
        return;
      }
    }

    if (type.id === 22) {
      // Validación: extremos vacíos
      if (
        information.textsBipolarBar.leftText.trim() === '' ||
        information.textsBipolarBar.rightText.trim() === ''
      ) {
        setErrorMessage((prev) => ({
          ...prev,
          bipolarText: true,
        }));
        setHelperText((prev) => ({
          ...prev,
          bipolarText:
            'Debe completar los textos de los extremos de la escala bipolar.',
        }));
        return;
      }
    }

    if (type.id === 27 || type.id === 26) {
      // Validación: extremos vacíos

      if (
        !selectedFileSelectQuestion ||
        Object.keys(selectedFileSelectQuestion).length === 0
      ) {
        setErrorMessage((prev) => ({
          ...prev,
          selectedFileSelectQuestionError: true,
        }));
        setHelperText((prev) => ({
          ...prev,
          selectedFileSelectQuestionHelpertext:
            'El archivo excel no puede estar vacío',
        }));
        return;
      }
      if (information.haveLimit) {
        const value = Number(information.limitOptions);

        if (
          !information.limitOptions ||
          information.limitOptions.toString().trim() === ''
        ) {
          setErrorMessage((prev) => ({
            ...prev,
            limitOptions: true,
          }));
          setHelperText((prev) => ({
            ...prev,
            limitOptions: 'El límite de opciones no puede estar vacío.',
          }));
          return;
        }

        if (isNaN(value)) {
          setErrorMessage((prev) => ({
            ...prev,
            limitOptions: true,
          }));
          setHelperText((prev) => ({
            ...prev,
            limitOptions: 'Debe ingresar un número válido.',
          }));
          return;
        }

        if (!Number.isInteger(value)) {
          setErrorMessage((prev) => ({
            ...prev,
            limitOptions: true,
          }));
          setHelperText((prev) => ({
            ...prev,
            limitOptions: 'Solo se permiten números enteros.',
          }));
          return;
        }

        if (value < 1) {
          setErrorMessage((prev) => ({
            ...prev,
            limitOptions: true,
          }));
          setHelperText((prev) => ({
            ...prev,
            limitOptions: 'El límite mínimo es de 1 opción.',
          }));
          return;
        }

        if (value > 10) {
          setErrorMessage((prev) => ({
            ...prev,
            limitOptions: true,
          }));
          setHelperText((prev) => ({
            ...prev,
            limitOptions: 'El límite máximo es de 10 opciones.',
          }));
          return;
        }
      }
    }
    if (type.id === 28) {
      if (!information.multimedia.type || !information.multimedia.urlMedia) {
        setErrorMessage((prev) => ({
          ...prev,
          multimedia: {
            ...(prev.multimedia ?? {}),
            general: true,
          },
        }));
        setHelperText((prev) => ({
          ...prev,
          multimedia: {
            ...(prev.multimedia ?? {}),
            general: 'Debe agregar una imagen, video o URL de YouTube.',
          },
        }));
        return;
      }

      if (
        information.multimedia.type === 'youtube' &&
        (typeof information.multimedia.urlMedia !== 'string' ||
          !validateYouTubeUrl(information.multimedia.urlMedia))
      ) {
        setErrorMessage((prev) => ({
          ...prev,
          multimedia: {
            ...(prev.multimedia ?? {}),
            youtube: true,
          },
        }));

        setHelperText((prev) => ({
          ...prev,
          multimedia: {
            ...(prev.multimedia ?? {}),
            youtubeMessage:
              'La URL ingresada no es válida. Asegúrese de que sea un enlace de YouTube.',
          },
        }));
        return;
      }

      // Limpiar errores si todo está bien
      setErrorMessage((prev) => ({
        ...prev,
        multimedia: {
          general: false,
          youtube: false,
        },
      }));

      setHelperText((prev) => ({
        ...prev,
        multimedia: {
          general: '',
          youtubeMessage: '',
        },
      }));
    }

    // Después de las validaciones de type.id === 28 y antes de validar categoría
    if (type.id === 29) {
      const tableOptions = information.tableSetting?.options || [];

      // Validar que haya al menos una columna
      if (tableOptions.length === 0) {
        enqueueSnackbar('Debe agregar al menos una columna a la tabla', {
          variant: 'error',
          autoHideDuration: 3000,
        });
        return;
      }

      // Validar que ninguna columna tenga el nombre vacío
      const hasEmptyColumn = tableOptions.some(
        (column) => !column.value || column.value.trim() === '',
      );

      if (hasEmptyColumn) {
        setErrorMessage((prev) => ({
          ...prev,
          columns: tableOptions.map(
            (col) => !col.value || col.value.trim() === '',
          ),
        }));
        setHelperText((prev) => ({
          ...prev,
          tableColumns: 'Todas las columnas deben tener un nombre',
        }));
        return;
      }
    }

    if (type.id != 21) {
      if (categoryId === '' || categoryId === null) {
        setCategoryError('Seleccione una categoría');

        return;
      }
    }

    setErrorMessage({});
    setHelperText({});
    setCustomOptionError([]);
    setOptionRelationalError([]);

    // validate questions
    if (type.id === 1) {
      handleAddQuestion({
        type: 'Texto corto',
        name: information.name,
        description: information.description,
        isRequired: information.isRequired,
        needSentimentalAnalisys: information.needSentimentalAnalisys,
        voiceEnabled: information.voiceEnabled,
        voiceDuration: information.voiceDuration,
        validationType: information.validationType,
        wordSizeLimit: information.wordSizeLimit,
        haveLimit: information.haveLimit,
      });
    } else if (type.id === 21) {
      handleAddQuestion({
        type: 'Texto Informativo',
        name: information.name,
        description: information.description,
        options: information.options,
      });
    } else if (type.id === 23) {
      handleAddQuestion({
        type: 'Fecha',
        name: information.name,
        description: information.description,
        options: information.options,
        isRequired: information.isRequired,
      });
    } else if (type.id === 2) {
      handleAddQuestion({
        type: 'Escala Likert',
        name: information.name,
        description: information.description,
        options: information.options,
        isRequired: information.isRequired,
      });
    } else if (type.id === 16) {
      handleAddQuestion({
        type: 'Escala Likert-ENG',
        name: information.name,
        description: information.description,
        options: information.options,
        isRequired: information.isRequired,
      });
    } else if (type.id === 3) {
      handleAddQuestion({
        type: 'Opción múltiple',
        name: information.name,
        description: information.description,
        customOptions: information.customOptions,
        stars: parseInt(information.maximunValueOptions),
        isRequired: information.isRequired,
      });
    } else if (type.id === 8) {
      handleAddQuestion({
        type: 'Opción única',
        name: information.name,
        description: information.description,
        customOptions: information.customOptions,
        conditionalQuestion: conditionalQuestion,
        childQuestionIds: [],
        isRequired: information.isRequired,
      });
    } else if (type.id === 5) {
      handleAddQuestion({
        type: 'Calificaciones',
        name: information.name,
        description: information.description,
        stars: information.stars,
        isRequired: information.isRequired,
      });
    } else if (type.id === 10) {
      handleAddQuestion({
        type: 'E-NPS',
        name: information.name,
        description: information.description,
        isRequired: information.isRequired,
      });
    } else if (type.id === 14) {
      handleAddQuestion({
        type: 'Sentimental',
        name: information.name,
        description: information.description,
        options: information.options,
        isRequired: information.isRequired,
      });
    } else if (type.id === 15) {
      handleAddQuestion({
        type: 'Relacional',
        name: information.name,
        description: information.description,
        customOptions: information.customOptions,
        selectOptions: information.opcionesInputs,
        isRequired: information.isRequired,
      });
    } else if (type.id === 19) {
      handleAddQuestion({
        type: 'Bipolar',
        name: information.name,
        description: information.description,
        stars: information.barBipolarValue,
        textsBipolarBar: information.textsBipolarBar,
        isRequired: information.isRequired,
      });
    } else if (type.id === 22) {
      handleAddQuestion({
        type: 'Escala de Opinión',
        name: information.name,
        description: information.description,
        textsBipolarBar: information.textsBipolarBar,
        secondSelectOptions: Array.from({ length: 9 }, (_, i) =>
          (2 + i).toString(),
        ),
        isRequired: information.isRequired,
      });
    } else if (type.id === 24) {
      handleAddQuestion({
        type: 'Suma Constante',
        name: information.name,
        description: information.description,
        stars: information.barBipolarValue,
        customOptions: information.customOptions,
        autoValidate: information.autoValidate,
        isRequired: information.isRequired,
      });
    } else if (type.id === 24) {
      handleAddQuestion({
        type: 'Suma Constante',
        name: information.name,
        description: information.description,
        stars: information.barBipolarValue,
        customOptions: information.customOptions,
        autoValidate: information.autoValidate,
        isRequired: information.isRequired,
      });
    } else if (type.id === 25) {
      const rows = information.matrixOption?.options || [];
      const columns = information.matrixOption?.values || [];

      const shouldValidateRows =
        information.matrixOption?.matrixType !== 'dynamic';

      const isDynamic = information.matrixOption?.matrixType === 'dynamic';
      const dynamicOptions = information.matrixOption?.options || [];
      const nonEmptyOptions = dynamicOptions.filter(
        (opt) => opt && opt.toString().trim() !== '',
      );
      const isExcelEmpty = isDynamic && nonEmptyOptions.length === 0;
      const hasEmptyRow = shouldValidateRows
        ? rows.some((row) => !row || row.trim() === '')
        : false;
      const hasEmptyColumn = columns.some((col) => !col || col.trim() === '');
      if (hasEmptyRow || hasEmptyColumn || isExcelEmpty) {
        setErrorMessage((prev) => ({
          ...prev,
          matrixRows: shouldValidateRows
            ? rows.map((row) => !row || row.trim() === '')
            : [], // no marcar errores si no se validan
          matrixCols: columns.map((col) => !col || col.trim() === ''),
        }));
        setHelperText((prev) => ({
          ...prev,
          matrix: isExcelEmpty
            ? 'Debes cargar un archivo Excel con al menos una opción.'
            : 'Este campo no puede ir vacío',
        }));
        return;
      }
      handleAddQuestion({
        type: 'Matriz',
        name: information.name,
        description: information.description,
        matrixOption: information.matrixOption,
        isRequired: information.isRequired,
      });
    } else if (type.id === 26) {
      handleAddQuestion({
        type: 'Compuesta',
        name: information.name,
        description: information.description,
        customOptions: information.customOptions,
        file: information.file,
        isRequired: information.isRequired,
      });
    } else if (type.id === 27) {
      handleAddQuestion({
        type: 'Seleccion Gran escala',
        name: information.name,
        description: information.description,
        customOptions: information.customOptions,
        file: information.file,
        isRequired: information.isRequired,
        haveLimit: information.haveLimit,
        limitOptions: information.limitOptions,
      });
    } else if (type.id === 28) {
      handleAddQuestion({
        type: 'Multimedia',
        name: information.name,
        description: information.description,
        multimedia: {
          type: information.multimedia.type,
          urlMedia: information.multimedia.urlMedia,
          fileName: information.multimedia.fileName,
        },
      });
    } else if (type.id === 29) {
      handleAddQuestion({
        type: 'Tabla',
        name: information.name,
        description: information.description,
        tableSetting: information.tableSetting,
      });
    } else if (type.id === 30) {
      handleAddQuestion({
        type: 'Archivos',
        name: information.name,
        description: information.description,
        customOptions: information.customOptions,
        stars: information.barBipolarValue,
        limitOptions: information.limitOptions,
        isRequired: information.isRequired,
      });
    }

    setInformation({
      name: '',
      description: '',
      options: [],
      customOptions: Array(2).fill(''),
      opcionesInputs: Array(2).fill(''),
      stars: Array(3).fill(''),
      rangeOptions: ['Rango 0-6', 'Rango 7-8', 'Rango 9-10'],
      barBipolarValue: 0,
      textsBipolarBar: {
        leftText: '',
        rightText: '',
        valueRight: '2',
        valueLeft: '0',
      },
      maximunValueOptions: '',
      secondSelectOptions: Array.from({ length: 9 }, (_, i) =>
        (2 + i).toString(),
      ),
      isRequired: true,
      needSentimentalAnalisys: false,
      matrixOption: {
        matrixType: '',
        options: [''],
        values: [''],
        inputType: '',
      },
      tableSetting: {
        options: [
          {
            required: false,
            type: 'text',
            value: '',
          },
        ],
      },
      multimedia: {
        type: '',
        urlMedia: '',
      },
      voiceEnabled: false,
      voiceDuration: 60,
      validationType: 'text',
      wordSizeLimit: 500,
      haveLimit: true,
      limitOptions: 1,
    });
    setQuestion(null);
    setType(null);
    setCategoryId(null);
    handleCloseModal();
  };

  /**
   * Add new question.
   *
   * @param {object} question
   */
  const handleAddQuestion = async (
    question,
    typeId,
    isFromExcel,
    categoriaExcel,
    questionNumberExcel,
  ) => {
    const newQuestion = {
      id: uuid.v4(),
      categoryId: isFromExcel ? categoriaExcel : categoryId,
      typeId: type?.id || typeId,
      questionId: null,
      questionOptions: [],
      questionNumber: isFromExcel ? questionNumberExcel : questions.length + 1,
      ...question,
    };

    if (isTemplate && isUpdate) {
      const { questionId, questionOptions } =
        await updateTemplateQuestion(newQuestion);

      newQuestion.questionId = questionId;
      newQuestion.questionOptions = questionOptions;
    }

    if (!newQuestion.customOptions || newQuestion.customOptions.length === 0) {
      newQuestion.customOptions = newQuestion.options;
    }

    setQuestions((previousQuestions) => [...previousQuestions, newQuestion]);
  };

  /**
   * Handle delete question.
   *
   * @param {number} id The id of the question to be deleted.
   */
  const handleDelete = async (id) => {
    const question = questions.find((q) => q.id === id);

    // 1. Eliminar la pregunta
    const updatedQuestions = questions.filter((q) => q.id !== id);

    // 2. Reorganizar los questionNumber
    const reorderedQuestions = updatedQuestions.map((q, index) => ({
      ...q,
      questionNumber: index + 1,
    }));

    // 3. Trasladar las hijas de las condicionales a la nueva numeración y actualizar el estado
    const { questions: remappedQuestions, newNumberById } =
      remapConditionalChildren(questions, reorderedQuestions);
    remapChildSelections(newNumberById);
    setQuestions(remappedQuestions);

    // 5. Llamar al API
    //await deleteTemplateQuestionAPI(question.id);
    enqueueSnackbar('Pregunta eliminada', { variant: 'success' });
  };

  /**
   * Return header title.
   *
   * @returns {string}
   */
  const getHeaderTitle = () => {
    if (isTemplate && isMap && !isEdit) {
      return 'Crear encuesta de mapa';
    } else if (isTemplate && isMap && isEdit) {
      return 'Editar encuesta de mapa';
    } else if (isTemplate) {
      return 'Crear plantilla';
    }
    if (isEdit) {
      return 'Editar encuesta';
    } else {
      return 'Crear encuesta';
    }
  };

  // Función para validar URL
  const isValidUrl = (string) => {
    if (!string) return true; // Permitir vacío
    try {
      const url = new URL(string);
      return url.protocol === 'http:' || url.protocol === 'https:';
    } catch (_) {
      return false;
    }
  };

  // Handler para el cambio de URL con validación
  const handleUrlChange = (e) => {
    const value = e.target.value;
    setDataPrivacyPolicyUrl(value);

    if (value && !isValidUrl(value)) {
      setUrlError('Ingrese una URL válida (ej: https://ejemplo.com)');
    } else {
      setUrlError('');
    }
  };

  /**
   * Fetch categories.
   *
   * @returns {Promise<void>}
   */
  const fetchCategories = async () => {
    if (!currentCompany) return;
    const { data } = await fetchCategoriesByCompanyAPI(currentCompany.id);

    setCategories(data);
  };

  /**
   * Fetch question types.
   *
   * @returns {Promise<void>}
   */
  const fetchQuestionTypes = async () => {
    const { data } = await fetchQuestionTypesAPI();

    setQuestionTypes(data);
  };

  /**
   * Fetch survey and fill form data.
   *
   * @param {number} templateId
   */
  const fetchSurvey = async (templateId) => {
    //if (!currentCompany) {return;}
    const { data: survey } = await client.get(
      `ShowQuestion/${surveyId}/${currentCompany.id}`,
    );
    let dataCopy = {
      ...data,
    };
    console.log(survey);
    // fill journey map
    if (survey.response) {
      dataCopy = {
        ...dataCopy,
        map: survey.response.map,
      };
    }
    // fill name
    if (survey.response?.surveyName) {
      dataCopy = {
        ...dataCopy,
        title: survey.response.surveyName,
      };
    }
    // fill description
    if (survey.response?.description) {
      dataCopy = {
        ...dataCopy,
        description: survey.response.description,
      };
    }
    if (survey.response?.emailMAsk) {
      dataCopy = {
        ...dataCopy,
        emailMask: survey.response.emailMAsk,
      };
    }
    if (survey.response?.emailSubject) {
      dataCopy = {
        ...dataCopy,
        emailSubject: survey.response.emailSubject,
      };
    }
    if (survey.response?.emailMessage) {
      dataCopy = {
        ...dataCopy,
        mailingMessage: survey.response.emailMessage,
      };
    }

    if (survey.response.hasNumerationNumber != null) {
      setHasNumerationNumber(survey.response?.hasNumerationNumber);
    }

    if (survey.response?.hasWhatsApp != null) {
      setHasWhatsApp(survey.response.hasWhatsApp);
    }

    if (survey.response?.includeLogo != null) {
      setIncludeLogo(survey.response?.includeLogo);
    }

    if (survey.response?.inputMessage) {
      setSurveyMessages((prev) => ({
        ...prev,
        inputMessage: survey.response?.inputMessage,
      }));
    }
    if (survey.response?.welcomeMessage) {
      setSurveyMessages((prev) => ({
        ...prev,
        welcomeMessage: survey.response.welcomeMessage,
      }));
    }

    if (survey.response?.confindencialityMessage) {
      setSurveyMessages((prev) => ({
        ...prev,
        confidentialityMessage: survey.response.confindencialityMessage,
      }));
    }

    if (survey.response?.pagination) {
      setQuestionsPerPage(survey.response?.pagination);
    }

    if (survey.response?.isBuzon) {
      setOpenMailBox(survey.response?.isBuzon);
    }
    if (survey.response?.reports?.length > 0) {
      setHaveEvaAgents(true);
      setReportConfigurationIds(survey.response.reports.map((r) => r.id));
    }
    if (survey.response?.haveReportPdf != null) {
      setHaveReportPDF(survey.response.haveReportPdf);
    }

    if (survey.response?.requiredInputMailBox) {
      setSurveyOpenMailBoxMessages((prev) => ({
        ...prev,
        inputMessage: survey.response?.requiredInputMailBox,
      }));
    }

    if (survey.response.textSettings) {
      const settings = survey.response.textSettings || '{}';
      setPrimaryColor(settings.primaryColor);
      setSecondaryColor(settings.secondaryColor);
      setBannerImage(settings.urlBanner);
      setBackgroundImage(settings.urlBackground);
      setTextTypeGenericInput(settings.textType);
      setIsEnabledIntroduction(settings.hasIntroduction);
      setIntroductionText(settings.introductionText);
    }
    // Ojo con el nombre: el backend devuelve haveUser INVERTIDO respecto de la columna
    // (JourneyController: HaveUser = !survey.HaveUser). En la respuesta significa
    // "requiere identificación", así que la encuesta es totalmente anónima cuando viene
    // en false. Tomarlo tal cual marcaba como anónima justo a las que piden
    // identificación: eso deshabilitaba el acceso restringido y, al guardar, mandaba
    // exclusive = false, dejando la encuesta abierta cada vez que se editaba.
    if (survey.response?.haveUser != null) {
      setIsCompletedAnonymous(!survey.response.haveUser);
    }

    // Abierta o restringida a su audiencia. Sin esto el radio mostraba el valor por
    // defecto y no lo que tiene la encuesta.
    if (survey.response?.exclusive != null) {
      setExclusiviness(survey.response.exclusive);
    }

    if (survey.response?.answerDate) {
      setClosingDate(dayjs(survey.response.answerDate));
    }

    if (survey.response?.startDate) {
      setStartDate(dayjs(survey.response.startDate));
    }

    if (survey.response?.saveOption != null) {
      setSaveOption(survey.response.saveOption);
    }

    // Cargar políticas de privacidad
    if (survey.response?.policyPrivacySettings.isPrivacyPolicyEnabled != null) {
      setPrivacyPolicyEnabled(
        survey.response.policyPrivacySettings.isPrivacyPolicyEnabled,
      );
    }
    if (survey.response?.policyPrivacySettings.dataPrivacyPolicyUrl) {
      setDataPrivacyPolicyUrl(
        survey.response.policyPrivacySettings.dataPrivacyPolicyUrl,
      );
    }

    if (survey.response?.policyPrivacySettings.dataPrivacyPolicyText) {
      setDataPrivacyPolicyText(
        survey.response.policyPrivacySettings.dataPrivacyPolicyText,
      );
    }
    if (survey.response?.policyPrivacySettings.dataPrivacyPolicyText) {
      setCheckboxLabel(survey.response.policyPrivacySettings.checkboxText);
    }
    if (survey.response?.policyPrivacySettings.buttonAceotText) {
      setAcceptButtonText(
        survey.response.policyPrivacySettings.buttonAceotText,
      );
    }
    if (survey.response?.policyPrivacySettings.buttonDeclineText) {
      setDeclineButtonText(
        survey.response.policyPrivacySettings.buttonDeclineText,
      );
    }

    if (survey.response?.policyPrivacySettings?.declineMessage) {
      setDeclineMessage((prev) => ({
        ...prev, // fallback a defaults
        ...survey.response?.policyPrivacySettings?.declineMessage,
      }));
    }

    if (survey.response?.maxAnswer != null) {
      setMaxResponses(survey.response?.maxAnswer);
      if (survey.response?.maxAnswer > 0) {
        setResponseLimitEnabled(true);
      }
    }
    // Cargar FontFamily
    if (survey.response?.fontFamily) {
      setSelectedFont(survey.response.fontFamily);
    }

    setData(dataCopy);

    //let questionsCopy = [...questions];
    const questionsCopy = [];
    // fill questions
    survey.response.preguntas.forEach((question) => {
      const isTextQuestion = question.typeQuestionId === 1;
      const isBigScaleQuestion = question.typeQuestionId === 27;
      const isComposite = question.typeQuestionId === 26;

      questionsCopy.push({
        id: uuid.v4(),
        questionNumber: question.questionNumber,
        questionId: question.questionId,
        typeId: question.typeQuestionId,
        categoryId: question.categoryId,
        type: question.typeQuestion,
        name: question.questionName,
        description: question.description,
        ...(question.multimedia
          ? {
              multimedia: {
                type: question.multimedia.type,
                urlMedia: question.multimedia.urlMedia,
              },
            }
          : {}),
        customOptions: question.typeQuestionId === 30
          ? question.options.map((option) => option.optionName)
          : question.options.map((option) => ({
              value: option.optionName,
              ...(option.isOther && { isOther: true }),
              ...(option.isOther && {
                fixedIndex: question.options.filter(o => !o.isOther).length,
              }),
            })).sort((a, b) => (a.isOther ? 1 : 0) - (b.isOther ? 1 : 0)),
        selectOptions:
          question.selectOptions?.map((option) => option.selectOption) ??
          Array(2).fill(''),
        options: question.options.map((option) => ({
          optionName: option.optionName,
          ...(question.conditionalQuestion && {
            numberOption: option.numberOption,
            questionChildren: option.questionChildren,
          }),
        })),
        questionOptions: question.options,
        stars: getScore2(question),
        childQuestionIds: question.options.map(
          (opt) => opt.questionChildren ?? '',
        ),
        ...(question.typeQuestionId === 30
          ? {
              maxFiles: question?.limitOptions ?? 1,
            }
          : {}),
        //...(question.textsBipolarBar && {
        textsBipolarBar: {
          leftText: question.textsBipolarBar?.leftText ?? '',
          rightText: question.textsBipolarBar?.rightText ?? '',
          valueRight: question.textsBipolarBar?.valueRight ?? '',
          valueLeft: question.textsBipolarBar?.valueLeft ?? '',
        },
        //}),
        autoValidate: question.autovalidate,
        matrixOption:
          question.matrixOption &&
          (question.matrixOption.options?.length > 0 ||
            question.matrixOption.values?.length > 0)
            ? question.matrixOption
            : null,
        ...(question.typeQuestionId !== 26 && question.complexChildQuestionId
          ? { complexChildQuestionId: question.complexChildQuestionId }
          : {}),
        ...(isComposite && {
          complexParentId: question.complexParentId,
        }),
        limitType:
          Array.isArray(question.score) && question.score.length > 0
            ? 'fijo'
            : 'ilimitado',
        secondSelectOptions: Array.from({ length: 9 }, (_, i) =>
          (2 + i).toString(),
        ),
        ...(question.tableSetting?.options && {
          tableSetting: {
            options: question.tableSetting.options,
          },
        }),
        maxFile: question.maxFile,
        conditionalQuestion: question.conditional,
        isRequired: question.required,
        needSentimentalAnalisys: question.needSentimentalAnalisys,
        ...((isTextQuestion || isBigScaleQuestion) && {
          voiceEnabled: question.settings?.microphoneEnabled ?? false,
          voiceDuration: question.settings?.responseTimeoutSeconds ?? 60,
          validationType: question.settings?.textType ?? 'text',
          wordSizeLimit: question.settings?.wordSizeLimit ?? 500,
          haveLimit: question.settings?.haveLimit ?? true,
          limitOptions: question.settings?.limitOptions ?? 1,
        }),
      });
    });
    setQuestions(questionsCopy);
    originalQuestionsRef.current = questionsCopy.map((q) =>
      JSON.parse(JSON.stringify(q)),
    );
    setDemographics(survey.response.demographics);
    /*
      setTemplateDemographics(
        template.templateDemographics.map((demographic) => demographic.name)
      );*/
  };
  const hasQuestionChanged = (question) => {
    const original = originalQuestionsRef.current.find(
      (q) => q.questionId === question.questionId,
    );
    if (!original) return true; // es nueva, siempre enviar

    const fields = [
      'name',
      'description',
      'typeId',
      'isRequired',
      'needSentimentalAnalisys',
      'conditionalQuestion',
      'autoValidate',
      'voiceEnabled',
      'voiceDuration',
      'validationType',
      'wordSizeLimit',
      'haveLimit',
      'limitOptions',
      'categoryId',
    ];

    for (const field of fields) {
      if (JSON.stringify(question[field]) !== JSON.stringify(original[field])) {
        return true;
      }
    }

    // Comparar opciones
    if (
      JSON.stringify(question.customOptions) !==
      JSON.stringify(original.customOptions)
    )
      return true;

    if (
      JSON.stringify(question.selectOptions) !==
      JSON.stringify(original.selectOptions)
    )
      return true;

    // Comparar textsBipolarBar
    if (
      JSON.stringify(question.textsBipolarBar) !==
      JSON.stringify(original.textsBipolarBar)
    )
      return true;

    // Comparar matrixOption
    if (
      JSON.stringify(question.matrixOption) !==
      JSON.stringify(original.matrixOption)
    )
      return true;

    // Comparar tableSetting
    if (
      JSON.stringify(question.tableSetting) !==
      JSON.stringify(original.tableSetting)
    )
      return true;

    return false;
  };

  /**
   * Fetch template and fill form data.
   *
   * @param {number} templateId
   */
  const fetchTemplate = async (templateId) => {
    const { data: template } = await showTemplateAPI(templateId);
    if (!template) {
      return;
    }
    let dataCopy = {
      ...data,
    };

    // fill journey map
    if (template.template?.journeyMap) {
      dataCopy = {
        ...dataCopy,
        map: template.template.journeyMap,
      };
    }
    // fill name
    if (template.template?.nameSurvey) {
      dataCopy = {
        ...dataCopy,
        title: template.template.nameSurvey,
      };
    }
    // fill description
    if (template.template?.descriptionSurvey) {
      dataCopy = {
        ...dataCopy,
        description: template.template.descriptionSurvey,
      };
    }
    if (template.template?.messageMail) {
      dataCopy = {
        ...dataCopy,
        mailingMessage: template.template.messageMail,
      };
    }
    if (template.template?.pagination) {
      dataCopy = {
        ...dataCopy,
        pagination: template.template.pagination,
      };
    }

    if (template.template?.settings) {
      const settings = JSON.parse(template.template.settings || '{}');
      setPrimaryColor(settings.primaryColor);
      setSecondaryColor(settings.secondaryColor);
    }

    setData(dataCopy);
    let questionsCopy = [...questions];
    // fill questions
    template.templatesQuestions.forEach((question) => {
      const isComposite = question.question.typeQuestionId === 26;
      const isChild = !isComposite && question.question.complexParentId;
      const isTextQuestion = question.question.typeQuestionId === 1;
      const isBigScaleQuestion = question.question.typeQuestionId === 27;
      questionsCopy.push({
        id: uuid.v4(),
        questionId: question.question.id,
        typeId: question.question.typeQuestionId,
        categoryId: question.categoryId,
        type: question.question.type,
        name: question.question.nameQuestion,
        description: question.question.description,
        required: question.question.required,
        customOptions: question.options.map((option) => ({
          value: option.templateOptionsName,
          ...(option.isOther && { isOther: true }),
        })),
        options: question.options.map((option) => option.templateOptionsName),
        questionOptions: question.options,
        stars: Array.isArray(question.question.score)
          ? question.question.typeQuestionId == 19
            ? question.question.score[0]
            : question.question.score.length
          : question.question.score,
        selectOptions: question.selectOptions?.map(
          (option) => option.selectOption,
        ),
        questionNumber: question.question.numberQuestion,
        childQuestionIds: [],
        ...(question.question.textsBipolarBar && {
          textsBipolarBar: {
            leftText: question.question.textsBipolarBar.leftText,
            rightText: question.question.textsBipolarBar.rightText,
            valueRight: question.question.textsBipolarBar.valueRight,
            valueLeft: question.question.textsBipolarBar.valueLeft,
          },
        }),
        autoValidate: question.question.autoValidate,
        matrixOption:
          question.question.matrixOption &&
          (question.question.matrixOption.options?.length > 0 ||
            question.question.matrixOption.values?.length > 0)
            ? question.question.matrixOption
            : null,

        ...(question.question.typeQuestionId !== 26 &&
        question.question.complexChildQuestionId
          ? { complexChildQuestionId: question.question.complexChildQuestionId }
          : {}),

        // ✅ Conserva complexParentId en preguntas compuestas
        ...(isComposite && {
          complexParentId: question.question.complexParentId,
        }),

        limitType:
          Array.isArray(question.question.score) &&
          question.question.score.length > 0
            ? 'fijo'
            : 'ilimitado',

        secondSelectOptions: Array.from({ length: 9 }, (_, i) =>
          (2 + i).toString(),
        ),
        isRequired: question.question.required,
        NeedSentimentalAnalisys: question.question.needSentimentalAnalisys,
        ...(isTextQuestion && {
          voiceEnabled: question.question.settings?.microphoneEnabled ?? false,
          voiceDuration:
            question.question.settings?.responseTimeoutSeconds ?? 60,
          validationType: question.question.settings?.textType ?? 'text',
          wordSizeLimit: question.question.settings?.wordSizeLimit ?? 500,
          haveLimit: question.question.settings?.haveLimit ?? 'limited',
        }),
        ...(isBigScaleQuestion && {
          limitOptions: question.question.settings?.limitOptions ?? 10,
          haveLimit: question.question.settings?.haveLimit ?? 'limited',
        }),
      });
    });
    setQuestions(questionsCopy);
    setTemplateDemographics(
      template.templateDemographics.map((demographic) => demographic.name),
    );
  };

  useEffect(() => {
    if (
      userInfo?.role.findIndex((p) => p === 'Journey') < 0 &&
      userInfo?.role.findIndex((p) => p === 'Administrador') < 0
    ) {
      alert('No tiene permiso para acceder a esta funcionalidad');
      navigate('/dashboard');
    }
    setQuestions(questions);
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  // watch for changes in template id
  useEffect(() => {
    if (!templateId) {
      return;
    }
    fetchTemplate(templateId);
  }, [templateId]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    /*if (!surveyId) {
      return;
    }*/
    if (!surveyId || !currentCompany) return;
    fetchSurvey(templateId);
  }, [surveyId, currentCompany]); // eslint-disable-line react-hooks/exhaustive-deps

  // component did mount
  useEffect(() => {
    fetchCategories();
    fetchQuestionTypes();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    fetchCategories();
  }, [currentCompany]); // eslint-disable-line react-hooks/exhaustive-deps

  // ✅ Agregar después de los imports, antes del componente
  const calculateDisplayNumbers = (questions) => {
    let mainQuestionCounter = 0;
    const parentCounters = {};

    // PRIMERA PASADA: Solo preguntas principales
    const firstPass = questions.map((question) => {
      // ✅ CAMBIO: Detectar hijas usando parentId O complexChildQuestionId
      if (question.complexChildQuestionId || question.parentId) {
        return { ...question };
      }

      mainQuestionCounter++;

      return {
        ...question,
        displayNumber: mainQuestionCounter,
        isChild: false,
      };
    });

    // SEGUNDA PASADA: Procesar hijas
    return firstPass.map((question) => {
      // ✅ CAMBIO: Si no es hija, devolverla
      if (!question.complexChildQuestionId && !question.parentId) {
        return question;
      }

      // ✅ CAMBIO: Usar parentId O complexChildQuestionId
      const parentId = question.complexChildQuestionId || question.parentId;

      if (!parentCounters[parentId]) {
        parentCounters[parentId] = 0;
      }

      parentCounters[parentId]++;

      // Buscar el padre
      const parentQuestion = firstPass.find((q) => q.id === parentId);

      const parentNumber = parentQuestion?.displayNumber || 1;

      return {
        ...question,
        displayNumber: `${parentNumber}.${parentCounters[parentId]}`,
        isChild: true,
      };
    });
  };

  return (
    <Box sx={{ display: 'flex' }}>
      <Dialog maxWidth="lg" open={open} onClose={handleCloseModal}>
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
          }}
        >
          <DialogTitle>Agregar pregunta</DialogTitle>
          {type?.id && ![21, 28].includes(type?.id) && (
            <IsRequiredQuestion
              isRequired={information.isRequired}
              onChangeSwitch={handleInformation}
            />
          )}

          {type?.id == 1 && (
            <NeedSentimentalAnalisys
              needSentimentalAnalisys={information.needSentimentalAnalisys}
              onChangeSwitch={handleInformation}
            />
          )}
          {type?.id == 25 && (
            <Button
              variant="outlined"
              onClick={() => setIsPreviewQuestion(true)}
              sx={{ marginRight: '10px' }}
              startIcon={<VisibilityIcon />}
            >
              Vista previa
            </Button>
          )}
        </Box>
        <DialogContent>
          <Box className={styles.modal}>
            <div className={styles.modalbuttom}>
              <div className={styles.form}>
                <div className={styles.input}>
                  <Autocomplete
                    id="combo-box-demo"
                    style={{ flexBasis: '40%' }}
                    options={
                      questionTypes.filter((q) => {
                        if (
                          saveOption &&
                          !SAVE_OPTION_QUESTION_TYPE_IDS.includes(q.id)
                        ) {
                          return false;
                        }

                        if (
                          hasWhatsApp &&
                          !WHATSAPP_QUESTION_TYPE_IDS.includes(q.id)
                        ) {
                          return false;
                        }

                        return true;
                      })
                    }
                    value={type}
                    onChange={(e, value) => {
                      handleAutocomplete(value);
                    }}
                    getOptionLabel={(option) => option.typeQuestionName}
                    noOptionsText={'No se encontraron tipos de pregunta'}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        error={errorMessage.IdTipoDocumento}
                        helperText={helperText.IdTipoDocumento}
                        label={
                          hasWhatsApp
                            ? 'Tipo de pregunta compatible con WhatsApp'
                            : 'Seleccionar tipo de pregunta'
                        }
                      />
                    )}
                    size="small"
                    isOptionEqualToValue={(option, value) =>
                      option.id === value.id
                    }
                  />
                  {hasWhatsApp && (
                    <FormHelperText>
                      WhatsApp permite texto, selección, Likert y texto
                      informativo.
                    </FormHelperText>
                  )}
                </div>
                <Form
                  type={type}
                  information={information}
                  setInformation={setInformation}
                  handleInformation={handleInformation}
                  errorMessage={errorMessage}
                  helperText={helperText}
                  setErrorMessage={setErrorMessage}
                  setHelperText={setHelperText}
                  handleinformationoptions={handleinformationoptions}
                  handleInformationRelationalOptions={
                    handleInformationRelationalOptions
                  }
                  handleChangeOptions={handleChangeOptions}
                  handleaddoption={handleaddoption}
                  handleRemoveOption={handleRemoveOption}
                  handleaddstars={handleaddstars}
                  handledeletestars={handledeletestars}
                  starmsg={starmsg}
                  handleCategoryIdChange={handleCategoryIdChange}
                  categories={categories}
                  categoryError={categoryError}
                  questions={(() => {
                    // ✅ Contar solo preguntas PRINCIPALES (sin hijas)
                    const mainQuestions = questions.filter(
                      (q) => !q.complexChildQuestionId && !q.parentId,
                    );
                    // La próxima pregunta principal será N+1
                    return mainQuestions.length + 1;
                  })()}
                  customOptionError={customOptionError}
                  optionRelationalError={optionRelationalError}
                  questionTypes={questionTypes}
                  handleAutocomplete={handleAutocomplete}
                  limitType={limitType}
                  setLimitType={setLimitType}
                  firstSelect={firstSelect}
                  setFirstSelect={setFirstSelect}
                  secondSelect={secondSelect}
                  setSecondSelect={setSecondSelect}
                  handleFirstSelectChange={handleFirstSelectChange}
                  handleSecondSelectChange={handleSecondSelectChange}
                  startValue={startValue}
                  secondSelectOptions={secondSelectOptions}
                  isPreviewQuestion={isPreviewQuestion}
                  setIsPreviewQuestion={setIsPreviewQuestion}
                  selectedFileSelectQuestion={selectedFileSelectQuestion}
                  setSelectedFileSelectQuestion={setSelectedFileSelectQuestion}
                  isUploadingFile={isUploadingFile}
                  setIsUploadingFile={setIsUploadingFile}
                  quillModules={quillModules}
                />
              </div>
            </div>
          </Box>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseModal} variant="outlined">
            Cancelar
          </Button>
          <Button
            onClick={handleAgregar}
            variant="contained"
            disabled={isUploadingFile}
          >
            Agregar
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog maxWidth="lg" onClose={handleCloseEditModal} open={edit}>
        <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
          <DialogTitle>Editar pregunta</DialogTitle>
          {question?.typeId && ![21, 28].includes(question?.typeId) && (
            <IsRequiredQuestion
              isRequired={question && question.isRequired}
              onChangeSwitch={handleQuestion}
            />
          )}

          {question?.typeId == 1 && (
            <NeedSentimentalAnalisys
              needSentimentalAnalisys={question.needSentimentalAnalisys}
              onChangeSwitch={handleQuestion}
            />
          )}
        </Box>

        <DialogContent>
          <Box className={styles.modal}>
            <div className={styles.modalbuttom}>
              <div className={styles.form}>
                {question && (
                  <EditForm
                    question={question}
                    setQuestion={setQuestion}
                    questions={questions}
                    handleInformation={handleQuestion}
                    errorMessage={errorMessage}
                    helperText={helperText}
                    setErrorMessage={setErrorMessage}
                    setHelperText={setHelperText}
                    handleInformationOptions={handleeditoption}
                    handleAddOption={handleeditaddoption}
                    handleRemoveOption={handleRemoveEditOption}
                    handleAddStars={handleeditstars}
                    handleDeleteStars={handleeditdeletestars}
                    starMessage={starmsg}
                    questionNumber={(() => {
                      const calculated = calculateDisplayNumbers(questions);
                      const currentQuestion = calculated[target];

                      // ✅ Retornar displayNumber (puede ser número o string "2.1")
                      return currentQuestion?.displayNumber || target + 1;
                    })()}
                    handleCategoryIdChange={handleCategoryIdChange}
                    categories={categories}
                    categoryError={categoryError}
                    handleChangeOptions={handleChangeOptions}
                    customOptionError={customOptionError}
                    conditionalQuestion={conditionalQuestion}
                    selections={selections}
                    setSelections={setSelections}
                    setChildQuestionNumber={setChildQuestionNumber}
                    handleInformationRelationalOptions={
                      handleInformationRelationalOptionsEdit
                    }
                    optionRelationalError={optionRelationalError}
                    limitType={limitType}
                    setLimitType={setLimitType}
                    selectedFileSelectQuestion={selectedFileSelectQuestion}
                    setSelectedFileSelectQuestion={
                      setSelectedFileSelectQuestion
                    }
                    isUploadingFile={isUploadingFile}
                    setIsUploadingFile={setIsUploadingFile}
                    updateQuestion={updateQuestion}
                    quillModules={quillModules}
                  />
                )}
              </div>
            </div>
          </Box>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseEditModal} variant="outlined">
            Cancelar
          </Button>
          <Button
            onClick={handleAgregar}
            variant="contained"
            disabled={isUploadingFile}
          >
            Actualizar
          </Button>
        </DialogActions>
      </Dialog>
      <Navbar />
      <IconSidebar />
      <div style={{ backgroundColor: 'white' }}>
        <div className={styles.content}>
          <div className={styles.survey_template}>
            <div className={styles.data}>
              <MyPageHeader
                title={getHeaderTitle()}
                Icon={<DesignServicesIcon />}
              />

              <div className={styles.display}>
                <Stepper activeStep={activeStep} className={styles.stepper}>
                  {steps.map((label, index) => {
                    return (
                      <Step key={label}>
                        <StepLabel>{label}</StepLabel>
                      </Step>
                    );
                  })}
                </Stepper>
              </div>
              <div className={styles.display}>{renderSwitch(activeStep)}</div>
              <div
                className={styles.display}
                style={{ position: 'sticky', bottom: 0 }}
              >
                <div className={styles.impexp}>
                  <Button variant="text" onClick={handleCerrar}>
                    {activeStep === 0 ? 'Cerrar' : 'atrás'}
                  </Button>
                  <Button
                    variant="contained"
                    onClick={handleNextStep}
                    disabled={
                      (activeStep === 6 && questions.length === 0) ||
                      (activeStep === 0 && view360.length === 0 && isView360) ||
                      ((activeStep === steps.length - 1 ||
                        (activeStep === 1 && isTemplate)) &&
                        loading)
                    }
                  >
                    {activeStep === steps.length - 1 ||
                    (activeStep === 1 && isTemplate)
                      ? 'Finalizar'
                      : 'Continuar'}
                  </Button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Box>
  );
}
